export default {
	formatXML1450: [
		{
			TargetName: 'Tag Hdon\\DLHDon\\TTChung',
			IsTitle: true
		},
		{
			TargetName: 'XML version',
			TagName: 'PBan',
			MaxLength: 6,
			DataType: 'String',
			Constraint: 'Mandatory',
			IsTitle: false,
			PathRoot: 'Tag Hdon\\DLHDon\\TTChung'
		},
		{
			TargetName: 'Invoice name',
			TagName: 'THDon',
			MaxLength: 100,
			DataType: 'String',
			Constraint: 'Mandatory (if available)',
			IsTitle: false,
			PathRoot: 'Tag Hdon\\DLHDon\\TTChung'
		},
		{
			TargetName: 'Pattern serial number of the invoice',
			TagName: 'KHMSHDon',
			MaxLength: 1,
			DataType: 'String (Details in Appendix 16 attached to Decision No. 1450/QD-TCT)',
			Constraint: 'Mandatory (if available)',
			IsTitle: false,
			PathRoot: 'Tag Hdon\\DLHDon\\TTChung'
		},
		{
			TargetName: 'Invoice symbol',
			TagName: 'KHHDon',
			MaxLength: 6,
			DataType: 'String',
			Constraint: 'Mandatory (if available)',
			IsTitle: false,
			PathRoot: 'Tag Hdon\\DLHDon\\TTChung'
		},
		{
			TargetName: 'Invoice number',
			TagName: 'SHDon',
			MaxLength: 8,
			DataType: 'Number',
			Constraint: 'Mandatory (if available)',
			IsTitle: false,
			PathRoot: 'Tag Hdon\\DLHDon\\TTChung'
		},
		{
			TargetName: 'Record code',
			TagName: 'MHSo',
			MaxLength: 20,
			DataType: 'String',
			Constraint: 'Mandatory (For invoices requesting codes issued by the tax authority for each occurrence)',
			IsTitle: false,
			PathRoot: 'Tag Hdon\\DLHDon\\TTChung'
		},
		{
			TargetName: 'Date of issuance',
			TagName: 'NLap',
			DataType: 'Date',
			Constraint: 'Mandatory',
			IsTitle: false,
			PathRoot: 'Tag Hdon\\DLHDon\\TTChung'
		},
		{
			TargetName: 'Manifest number (Number of manifest of goods and services sold with the invoice)',
			TagName: 'SBKe',
			MaxLength: 50,
			DataType: 'String',
			Constraint: 'Mandatory (if available)',
			IsTitle: false,
			PathRoot: 'Tag Hdon\\DLHDon\\TTChung'
		},
		{
			TargetName: 'Manifest date (Date of the manifest of goods and services sold with the invoice)',
			TagName: 'NBKe',
			DataType: 'Date',
			Constraint: 'Mandatory (if available)',
			IsTitle: false,
			PathRoot: 'Tag Hdon\\DLHDon\\TTChung'
		},
		{
			TargetName: 'Currency unit',
			TagName: 'DVTTe',
			MaxLength: 3,
			DataType:
				'String (Details in Section 2, Section IV, Part I of Decision No. 1450/QD-TCT dated October 7, 2021)',
			Constraint: 'Mandatory',
			IsTitle: false,
			PathRoot: 'Tag Hdon\\DLHDon\\TTChung'
		},
		{
			TargetName: 'Exchange rate',
			TagName: 'TGia',
			MaxLength: '7.2',
			DataType: 'Number',
			Constraint: 'Mandatory (Except when the Currency unit is VND)',
			IsTitle: false,
			PathRoot: 'Tag Hdon\\DLHDon\\TTChung'
		},
		{
			TargetName: 'Payment method',
			TagName: 'HTTToan',
			MaxLength: 50,
			DataType: 'String',
			Constraint: 'Not mandatory',
			IsTitle: false,
			PathRoot: 'Tag Hdon\\DLHDon\\TTChung'
		},
		{
			TargetName:
				'Taxpayer Identification Number (TIN) of the organization providing electronic invoice solutions',
			TagName: 'MSTTCGP',
			MaxLength: 14,
			DataType: 'String',
			Constraint:
				"Mandatory (except for cases of issuing electronic invoices with codes not collected on the tax authority's electronic portal)",
			IsTitle: false,
			PathRoot: 'Tag Hdon\\DLHDon\\TTChung'
		},
		{
			TargetName: 'Taxpayer Identification Number (TIN) of the unit authorized to issue invoices',
			TagName: 'MSTDVNUNLHDon',
			MaxLength: 14,
			DataType: 'String',
			Constraint: 'Mandatory (For cases of invoice authorization)',
			IsTitle: false,
			PathRoot: 'Tag Hdon\\DLHDon\\TTChung'
		},
		{
			TargetName: 'Name of the unit authorized to issue invoices',
			TagName: 'TDVNUNLHDon',
			MaxLength: 400,
			DataType: 'String',
			Constraint: 'Mandatory (For cases of invoice authorization)',
			IsTitle: false,
			PathRoot: 'Tag Hdon\\DLHDon\\TTChung'
		},
		{
			TargetName: 'Address of the unit authorized to issue invoices',
			TagName: 'DCDVNUNLHDon',
			MaxLength: 400,
			DataType: 'String',
			Constraint: 'Mandatory (For cases of invoice authorization)',
			IsTitle: false,
			PathRoot: 'Tag Hdon\\DLHDon\\TTChung'
		},
		{
			TargetName:
				'Tag Hdon\\DLHDon\\TTChung\\TTHDLQuan invoices contain information on related invoices in cases of adjustment or replacement invoices',
			IsTitle: true,
			PathRoot: 'Tag Hdon\\DLHDon\\TTChung'
		},
		{
			TargetName: 'Nature of the invoice',
			TagName: 'TCHDon',
			MaxLength: 1,
			DataType: 'Number (1: Replacement, 2: Adjustment)',
			Constraint: 'Mandatory',
			IsTitle: false,
			PathRoot:
				'Tag Hdon\\DLHDon\\TTChung\\TTHDLQuan invoices contain information on related invoices in cases of adjustment or replacement invoices'
		},
		{
			TargetName: 'Type of related invoice (Type of replaced/adjusted invoice)',
			TagName: 'LHDCLQuan',
			MaxLength: 1,
			DataType: 'Number (Details in Appendix VI attached to Decision No. 1450/QD-TCT dated October 7, 2021)',
			Constraint: 'Mandatory',
			IsTitle: false,
			PathRoot:
				'Tag Hdon\\DLHDon\\TTChung\\TTHDLQuan invoices contain information on related invoices in cases of adjustment or replacement invoices'
		},
		{
			TargetName: 'Template code of related invoice (Template code of replaced/adjusted invoice)',
			TagName: 'KHMSHDCLQuan',
			MaxLength: 11,
			DataType: 'String (Details in Section 16, Appendix attached to Decision No. 1450/QD-TCT)',
			Constraint:
				'Mandatory (For adjustment or replacement cases of invoices with Template code, Invoice code, Invoice number)',
			IsTitle: false,
			PathRoot:
				'Tag Hdon\\DLHDon\\TTChung\\TTHDLQuan invoices contain information on related invoices in cases of adjustment or replacement invoices'
		},
		{
			TargetName: 'Invoice code of related invoice (Invoice code of replaced/adjusted invoice)',
			TagName: 'KHHDCLQuan',
			MaxLength: 8,
			DataType: 'String',
			Constraint:
				'Mandatory (For adjustment or replacement cases of invoices with Template code, Invoice code, Invoice number)',
			IsTitle: false,
			PathRoot:
				'Tag Hdon\\DLHDon\\TTChung\\TTHDLQuan invoices contain information on related invoices in cases of adjustment or replacement invoices'
		},
		{
			TargetName: 'Invoice number of related invoice (Invoice number of replaced/adjusted invoice)',
			TagName: 'SHDCLQuan',
			MaxLength: 8,
			DataType: 'String',
			Constraint:
				'Mandatory (For adjustment or replacement cases of invoices with Template code, Invoice code, Invoice number)',
			IsTitle: false,
			PathRoot:
				'Tag Hdon\\DLHDon\\TTChung\\TTHDLQuan invoices contain information on related invoices in cases of adjustment or replacement invoices'
		},
		{
			TargetName: 'Date of related invoice (Date of replaced/adjusted invoice)',
			TagName: 'NLHDCLQuan',
			DataType: 'Date',
			Constraint: 'Mandatory',
			IsTitle: false,
			PathRoot:
				'Tag Hdon\\DLHDon\\TTChung\\TTHDLQuan invoices contain information on related invoices in cases of adjustment or replacement invoices'
		},
		{
			TargetName: 'Note',
			TagName: 'GChu',
			MaxLength: 255,
			DataType: 'String',
			Constraint: 'Not mandatory',
			IsTitle: false,
			PathRoot:
				'Tag Hdon\\DLHDon\\TTChung\\TTHDLQuan invoices contain information on related invoices in cases of adjustment or replacement invoices'
		},
		{
			TargetName: 'Tag HDon\\DLHDon\\NDHDon\\NBan',
			IsTitle: true
		},
		{
			TargetName: 'Name',
			TagName: 'Ten',
			MaxLength: 400,
			DataType: 'String',
			Constraint: 'Mandatory',
			IsTitle: false,
			PathRoot: 'Tag Hdon\\DLHDon\\NDHDon\\NBan'
		},
		{
			TargetName: 'Tax code',
			TagName: 'MST',
			MaxLength: 14,
			DataType: 'String',
			Constraint: 'Mandatory',
			IsTitle: false,
			PathRoot: 'Tag Hdon\\DLHDon\\NDHDon\\NBan'
		},
		{
			TargetName: 'Address',
			TagName: 'DChi',
			MaxLength: 400,
			DataType: 'String',
			Constraint: 'Mandatory',
			IsTitle: false,
			PathRoot: 'Tag Hdon\\DLHDon\\NDHDon\\NBan'
		},
		{
			TargetName: 'Phone number',
			TagName: 'SDThoai',
			MaxLength: 20,
			DataType: 'String',
			Constraint: 'Not mandatory',
			IsTitle: false,
			PathRoot: 'Tag Hdon\\DLHDon\\NDHDon\\NBan'
		},
		{
			TargetName: 'Email address',
			TagName: 'DCTDTu',
			MaxLength: 50,
			DataType: 'String',
			Constraint: 'Not mandatory',
			IsTitle: false,
			PathRoot: 'Tag Hdon\\DLHDon\\NDHDon\\NBan'
		},
		{
			TargetName: 'Bank account number',
			TagName: 'STKNHang',
			MaxLength: 30,
			DataType: 'String',
			Constraint: 'Not mandatory',
			IsTitle: false,
			PathRoot: 'Tag Hdon\\DLHDon\\NDHDon\\NBan'
		},
		{
			TargetName: 'Bank name',
			TagName: 'TNHang',
			MaxLength: 400,
			DataType: 'String',
			Constraint: 'Not mandatory',
			IsTitle: false,
			PathRoot: 'Tag Hdon\\DLHDon\\NDHDon\\NBan'
		},
		{
			TargetName: 'Fax',
			TagName: 'Fax',
			MaxLength: 20,
			DataType: 'String',
			Constraint: 'Not mandatory',
			IsTitle: false,
			PathRoot: 'Tag Hdon\\DLHDon\\NDHDon\\NBan'
		},
		{
			TargetName: 'Website',
			TagName: 'Website',
			MaxLength: 100,
			DataType: 'String',
			Constraint: 'Not mandatory',
			IsTitle: false,
			PathRoot: 'Tag Hdon\\DLHDon\\NDHDon\\NBan'
		},
		{
			TargetName: 'Tag HDon\\DLHDon\\NDHDon\\NMua',
			IsTitle: true
		},
		{
			TargetName: 'Name',
			TagName: 'Ten',
			MaxLength: 400,
			DataType: 'String',
			Constraint: 'Mandatory (if available)',
			IsTitle: false,
			PathRoot: 'Tag HDon\\DLHDon\\NDHDon\\NMua'
		},
		{
			TargetName: 'Tax code',
			TagName: 'MST',
			MaxLength: 14,
			DataType: 'String',
			Constraint: 'Mandatory (if available)',
			IsTitle: false,
			PathRoot: 'Tag HDon\\DLHDon\\NDHDon\\NMua'
		},
		{
			TargetName: 'Address',
			TagName: 'DChi',
			MaxLength: 400,
			DataType: 'String',
			Constraint: 'Mandatory (if available)',
			IsTitle: false,
			PathRoot: 'Tag HDon\\DLHDon\\NDHDon\\NMua'
		},
		{
			TargetName: 'Customer code',
			TagName: 'MKHang',
			MaxLength: 50,
			DataType: 'String',
			Constraint: 'Not mandatory',
			IsTitle: false,
			PathRoot: 'Tag HDon\\DLHDon\\NDHDon\\NMua'
		},
		{
			TargetName: 'Phone number',
			TagName: 'SDThoai',
			MaxLength: 20,
			DataType: 'String',
			Constraint: 'Not mandatory',
			IsTitle: false,
			PathRoot: 'Tag HDon\\DLHDon\\NDHDon\\NMua'
		},
		{
			TargetName: 'Email address',
			TagName: 'DCTDTu',
			MaxLength: 50,
			DataType: 'String',
			Constraint: 'Not mandatory',
			IsTitle: false,
			PathRoot: 'Tag HDon\\DLHDon\\NDHDon\\NMua'
		},
		{
			TargetName: 'Full name of buyer',
			TagName: 'HVTNMHang',
			MaxLength: 100,
			DataType: 'String',
			Constraint: 'Not mandatory',
			IsTitle: false,
			PathRoot: 'Tag HDon\\DLHDon\\NDHDon\\NMua'
		},
		{
			TargetName: 'Bank account number',
			TagName: 'STKNHang',
			MaxLength: 30,
			DataType: 'String',
			Constraint: 'Not mandatory',
			IsTitle: false,
			PathRoot: 'Tag HDon\\DLHDon\\NDHDon\\NMua'
		},
		{
			TargetName: 'Bank name',
			TagName: 'TNHang',
			MaxLength: 400,
			DataType: 'String',
			Constraint: 'Not mandatory',
			IsTitle: false,
			PathRoot: 'Tag HDon\\DLHDon\\NDHDon\\NMua'
		},
		{
			TargetName: 'Tag HDon\\DLHDon\\NDHDon\\DSHHDVuVHHDVu',
			IsTitle: true,
			PathRoot: 'Tag HDon\\DLHDon\\NDHDon\\NMua'
		},
		{
			TargetName: 'Nature',
			TagName: 'TChat',
			MaxLength: 1,
			DataType: 'Number (Details in Appendix IV attached to Decision No. 1450/QD-TCT dated 7/10/2021)',
			Constraint: 'Mandatory',
			IsTitle: false,
			PathRoot: 'Tag HDon\\DLHDon\\NDHDon\\DSHHDVuVHHDVu'
		},
		{
			TargetName: 'No.',
			TagName: 'STT',
			MaxLength: 4,
			DataType: 'Number',
			Constraint: 'Not mandatory',
			IsTitle: false,
			PathRoot: 'Tag HDon\\DLHDon\\NDHDon\\DSHHDVuVHHDVu'
		},
		{
			TargetName: 'Product, service code',
			TagName: 'MHHDVu',
			MaxLength: 50,
			DataType: 'String',
			Constraint: 'Mandatory (if available)',
			IsTitle: false,
			PathRoot: 'Tag HDon\\DLHDon\\NDHDon\\DSHHDVuVHHDVu'
		},
		{
			TargetName: 'Product, service name',
			TagName: 'THHDVu',
			MaxLength: 500,
			DataType: 'String',
			Constraint: 'Mandatory',
			IsTitle: false,
			PathRoot: 'Tag HDon\\DLHDon\\NDHDon\\DSHHDVuVHHDVu'
		},
		{
			TargetName: 'Unit',
			TagName: 'DVTinh',
			MaxLength: 50,
			DataType: 'String',
			Constraint: 'Mandatory (if available)',
			IsTitle: false,
			PathRoot: 'Tag HDon\\DLHDon\\NDHDon\\DSHHDVuVHHDVu'
		},
		{
			TargetName: 'Quantity',
			TagName: 'SLuong',
			MaxLength: '21.6',
			DataType: 'Number',
			Constraint: 'Mandatory (if available)',
			IsTitle: false,
			PathRoot: 'Tag Hdon\\DLHDon\\NDHDon\\DSHHDVuVHHDVu'
		},
		{
			TargetName: 'Unit price',
			TagName: 'DGia',
			MaxLength: '21.6',
			DataType: 'Number',
			Constraint: 'Mandatory (if available)',
			IsTitle: false,
			PathRoot: 'Tag Hdon\\DLHDon\\NDHDon\\DSHHDVuVHHDVu'
		},
		{
			TargetName: 'Discount rate (%) (In case of showing discount information for each item or service)',
			TagName: 'TLCKhau',
			MaxLength: '6.4',
			DataType: 'Number',
			Constraint: 'Not mandatory',
			IsTitle: false,
			PathRoot: 'Tag Hdon\\DLHDon\\NDHDon\\DSHHDVuVHHDVu'
		},
		{
			TargetName: 'Discount amount (In case of showing discount information for each item or service)',
			TagName: 'STCKhau',
			MaxLength: '21.6',
			DataType: 'Number',
			Constraint: 'Not mandatory',
			IsTitle: false,
			PathRoot: 'Tag Hdon\\DLHDon\\NDHDon\\DSHHDVuVHHDVu'
		},
		{
			TargetName: 'Total amount (Total amount excluding VAT)',
			TagName: 'ThTien',
			MaxLength: '21.6',
			DataType: 'Number',
			Constraint: 'Mandatory (except when TChat has the value “4-Note/explanation”)',
			IsTitle: false,
			PathRoot: 'Tag Hdon\\DLHDon\\NDHDon\\DSHHDVuVHHDVu'
		},
		{
			TargetName: 'Tax rate (VAT tax rate)',
			TagName: 'TSuat',
			MaxLength: 11,
			DataType: 'String (Details in Section 17 of the Appendix attached to Decision No. 1450/QD-TCT)',
			Constraint: 'Mandatory (if available)',
			IsTitle: false,
			PathRoot: 'Tag Hdon\\DLHDon\\NDHDon\\DSHHDVuVHHDVu'
		},
		{
			TargetName: 'Tag HdonVDLHDon\\NDHDon\\TToan\\THTTLTSuat\\LTSuat',
			IsTitle: true,
			PathRoot: 'Tag Hdon\\DLHDon\\NDHDon\\DSHHDVuVHHDVu'
		},
		{
			TargetName: 'Tax rate (VAT tax rate)',
			TagName: 'TSuat',
			MaxLength: 11,
			DataType: 'String (Details in Section 17 of the Appendix attached to Decision No. 1450/QD-TCT)',
			Constraint: 'Mandatory (if available)',
			IsTitle: false,
			PathRoot: 'Tag HdonVDLHDon\\NDHDon\\TToan\\THTTLTSuat\\LTSuat'
		},
		{
			TargetName: 'Total amount (Total amount excluding VAT)',
			TagName: 'ThTien',
			MaxLength: '21.6',
			DataType: 'Number',
			Constraint: 'Mandatory',
			IsTitle: false,
			PathRoot: 'Tag HdonVDLHDon\\NDHDon\\TToan\\THTTLTSuat\\LTSuat'
		},
		{
			TargetName: 'Tax amount (VAT tax amount)',
			TagName: 'TThue',
			MaxLength: '21.6',
			DataType: 'Number',
			Constraint: 'Mandatory (if available)',
			IsTitle: false,
			PathRoot: 'Tag HdonVDLHDon\\NDHDon\\TToan\\THTTLTSuat\\LTSuat'
		},
		{
			TargetName: 'Tag Hdon\\DLHDon\\NDHDon\\TToan',
			IsTitle: true,
			PathRoot: 'Tag HdonVDLHDon\\NDHDon\\TToan\\THTTLTSuat\\LTSuat'
		},
		{
			TargetName: 'Total amount excluding tax (Total amount excluding VAT)',
			TagName: 'TgTCThue',
			MaxLength: '21.6',
			DataType: 'Number',
			Constraint: 'Mandatory',
			IsTitle: false,
			PathRoot: 'Tag Hdon\\DLHDon\\NDHDon\\TToan'
		},
		{
			TargetName: 'Total non-taxable deduction',
			TagName: 'TGTKCThue',
			MaxLength: '21.6',
			DataType: 'Number',
			Constraint: 'Not mandatory',
			IsTitle: false,
			PathRoot: 'Tag Hdon\\DLHDon\\NDHDon\\TToan'
		},
		{
			TargetName: 'Total tax amount (Total VAT amount)',
			TagName: 'TgTThue',
			MaxLength: '21.6',
			DataType: 'Number',
			Constraint: 'Mandatory',
			IsTitle: false,
			PathRoot: 'Tag Hdon\\DLHDon\\NDHDon\\TToan'
		},
		{
			TargetName: 'Tag Hdon\\DLHDon\\NDHDon\\TToan\\DSLPhi\\LPhi',
			IsTitle: true,
			PathRoot: 'Tag Hdon\\DLHDon\\NDHDon\\TToan'
		},
		{
			TargetName: 'Fee name',
			TagName: 'TLPhi',
			MaxLength: 100,
			DataType: 'String',
			Constraint: 'Mandatory (if available)',
			IsTitle: false,
			PathRoot: 'Tag Hdon\\DLHDon\\NDHDon\\TToan\\DSLPhi\\LPhi'
		},
		{
			TargetName: 'Fee amount',
			TagName: 'TPhi',
			MaxLength: '21.6',
			DataType: 'Number',
			Constraint: 'Mandatory (if available)',
			IsTitle: false,
			PathRoot: 'Tag Hdon\\DLHDon\\NDHDon\\TToan\\DSLPhi\\LPhi'
		},
		{
			TargetName: 'Items placed inside the HDon\\DLHDon\\NDHDon\\TToan tag',
			IsTitle: true,
			PathRoot: 'Tag Hdon\\DLHDon\\NDHDon\\TToan\\DSLPhi\\LPhi'
		},
		{
			TargetName: 'Total commercial discount amount',
			TagName: 'TTCKTMai',
			MaxLength: '21.6',
			DataType: 'Number',
			Constraint: 'Mandatory (if available)',
			IsTitle: false,
			PathRoot: 'Items placed inside the HDon\\DLHDon\\NDHDon\\TToan'
		},
		{
			TargetName: 'Other deduction total',
			TagName: 'TGTKhac',
			MaxLength: '21.6',
			DataType: 'Number',
			Constraint: 'Not mandatory',
			IsTitle: false,
			PathRoot: 'Items placed inside the HDon\\DLHDon\\NDHDon\\TToan'
		},
		{
			TargetName: 'Total payment amount in numbers',
			TagName: 'TgTTTBSo',
			MaxLength: '21.6',
			DataType: 'Number',
			Constraint: 'Mandatory',
			IsTitle: false,
			PathRoot: 'Items placed inside the HDon\\DLHDon\\NDHDon\\TToan'
		},
		{
			TargetName: 'Total payment amount in words',
			TagName: 'TgTTTBChu',
			MaxLength: 255,
			DataType: 'String',
			Constraint: 'Mandatory',
			IsTitle: false,
			PathRoot: 'Items placed inside the HDon\\DLHDon\\NDHDon\\TToan'
		},
		{
			TargetName: 'HDon\\DLQRCode contains QR Code data',
			IsTitle: true,
			PathRoot: 'Items placed inside the HDon\\DLHDon\\NDHDon\\TToan'
		},
		{
			TargetName: 'QR Code data',
			TagNameCheck: 'DLQRCode',
			MaxLength: 512,
			DataType: 'String',
			Constraint: 'Not mandatory',
			IsTitle: false,
			PathRoot: 'HDon\\DLQRCode contains QR Code data'
		},
		{
			TargetName:
				'For invoices with codes, if conditions are met to issue codes, the tax authority system returns the item Tax authority code on electronic invoices (MCCQT tag, placed inside the HDon tag)',
			IsTitle: true,
			PathRoot: 'HDon\\DLQRCode contains QR Code data'
		},
		{
			TargetName: 'Tax authority code',
			TagName: 'MCCQT',
			MaxLength: 34,
			DataType: 'String',
			Constraint: 'Mandatory',
			IsTitle: false,
			PathRoot:
				'For invoices with codes, if conditions are met to issue codes, the tax authority system returns the item Tax authority code on electronic invoices (MCCQT tag, placed inside the HDon tag)'
		},
		{
			TargetName: 'HDon\\DSCKS\\NBan',
			IsTitle: true,
			PathRoot:
				'For invoices with codes, if conditions are met to issue codes, the tax authority system returns the item Tax authority code on electronic invoices (MCCQT tag, placed inside the HDon tag)'
		},
		{
			TargetName: "Seller's digital signature",
			TagName: 'Signature',
			Constraint: 'Mandatory (if available)',
			IsTitle: false,
			PathRoot: 'Tag Hdon\\DSCKS\\NBan'
		},
		{
			TargetName: 'Tag Hdon\\DSCKS\\NMua',
			IsTitle: true,
			PathRoot: 'Tag Hdon\\DSCKS\\NBan'
		},
		{
			TargetName: 'Digital signature of the buyer',
			TagName: 'Signature',
			Constraint: 'Not mandatory',
			IsTitle: false,
			PathRoot: 'Tag Hdon\\DSCKS\\NMua'
		},
		{
			TargetName:
				'For electronic invoices eligible for code issuance, the tax authority system returns the electronic invoice and adds the CQT tag (placed inside the HDonXDSCKS tag) containing the digital signature information of the tax authority (signed on the HDon\\DLHDon tag, MCCQT tag, and HDon\\DSCKS\\CQT\\Signature\\Object tag)',
			IsTitle: true,
			PathRoot: 'Tag Hdon\\DSCKS\\NMua'
		},
		{
			TargetName: 'Digital signature of the tax authority',
			TagName: 'Signature',
			Constraint: 'Mandatory',
			IsTitle: false,
			PathRoot:
				'For electronic invoices eligible for code issuance, the tax authority system returns the electronic invoice and adds the CQT tag (placed inside the HDonXDSCKS tag) containing the digital signature information of the tax authority (signed on the HDon\\DLHDon tag, MCCQT tag, and HDon\\DSCKS\\CQT\\Signature\\Object tag)'
		}
	],

	formatXMLBanHang: [
		{
			TargetName: 'Tag HDon\\DLHDon\\TTChung',
			IsTitle: true
		},
		{
			TargetName: 'XML version',
			TagName: 'PBan',
			MaxLength: 6,
			DataType: 'String',
			Constraint: 'Mandatory',
			IsTitle: false,
			PathRoot: 'Tag HDon\\DLHDon\\TTChung'
		},
		{
			TargetName: 'Invoice name',
			TagName: 'THDon',
			MaxLength: 100,
			DataType: 'String',
			Constraint: 'Mandatory (if available)',
			IsTitle: false,
			PathRoot: 'Tag HDon\\DLHDon\\TTChung'
		},
		{
			TargetName: 'Pattern serial number of the invoice',
			TagName: 'KHMSHDon',
			MaxLength: 1,
			DataType: 'String (Details in Appendix 16 attached to Decision No. 1450/QD-TCT)',
			Constraint: 'Mandatory (if available)',
			IsTitle: false,
			PathRoot: 'Tag HDon\\DLHDon\\TTChung'
		},
		{
			TargetName: 'Invoice symbol',
			TagName: 'KHHDon',
			MaxLength: 6,
			DataType: 'String',
			Constraint: 'Mandatory (if available)',
			IsTitle: false,
			PathRoot: 'Tag HDon\\DLHDon\\TTChung'
		},
		{
			TargetName: 'Invoice number',
			TagName: 'SHDon',
			MaxLength: 8,
			DataType: 'Number',
			Constraint: 'Mandatory (if available)',
			IsTitle: false,
			PathRoot: 'Tag HDon\\DLHDon\\TTChung'
		},
		{
			TargetName: 'Record code',
			TagName: 'MHSo',
			MaxLength: 20,
			DataType: 'String',
			Constraint: 'Mandatory (For invoices requesting codes issued by the tax authority for each occurrence)',
			IsTitle: false,
			PathRoot: 'Tag HDon\\DLHDon\\TTChung'
		},
		{
			TargetName: 'Date of issuance',
			TagName: 'NLap',
			DataType: 'Date',
			Constraint: 'Mandatory',
			IsTitle: false,
			PathRoot: 'Tag HDon\\DLHDon\\TTChung'
		},
		{
			TargetName:
				'Invoice for customs checkpoint (Invoice for organizations, individuals in the customs checkpoint)',
			TagName: 'HDDCKPTQuan',
			MaxLength: 1,
			DataType:
				'Number (1-Invoice for organizations, individuals in the customs checkpoint, 0-Invoice not for organizations, individuals in the customs checkpoint)',
			Constraint: 'Mandatory',
			IsTitle: false,
			PathRoot: 'Tag HDon\\DLHDon\\TTChung'
		},
		{
			TargetName: 'Manifest number (Number of manifest of goods and services sold with the invoice)',
			TagName: 'SBKe',
			MaxLength: 50,
			DataType: 'String',
			Constraint: 'Mandatory (if available)',
			IsTitle: false,
			PathRoot: 'Tag HDon\\DLHDon\\TTChung'
		},
		{
			TargetName: 'Manifest date (Date of the manifest of goods and services sold with the invoice)',
			TagName: 'NBKe',
			DataType: 'Date',
			Constraint: 'Mandatory (if available)',
			IsTitle: false,
			PathRoot: 'Tag HDon\\DLHDon\\TTChung'
		},
		{
			TargetName: 'Currency unit',
			TagName: 'DVTTe',
			MaxLength: 3,
			DataType:
				'String (Details in Section 2, Section IV, Part I of Decision No. 1450/QD-TCT dated October 7, 2021)',
			Constraint: 'Mandatory',
			IsTitle: false,
			PathRoot: 'Tag HDon\\DLHDon\\TTChung'
		},
		{
			TargetName: 'Exchange rate',
			TagName: 'TGia',
			MaxLength: '7.2',
			DataType: 'Number',
			Constraint: 'Mandatory (Except when the Currency unit is VND)',
			IsTitle: false,
			PathRoot: 'Tag HDon\\DLHDon\\TTChung'
		},
		{
			TargetName: 'Payment method',
			TagName: 'HTTToan',
			MaxLength: 50,
			DataType: 'String',
			Constraint: 'Not mandatory',
			IsTitle: false,
			PathRoot: 'Tag HDon\\DLHDon\\TTChung'
		},
		{
			TargetName:
				'Taxpayer Identification Number (TIN) of the organization providing electronic invoice solutions',
			TagName: 'MSTTCGP',
			MaxLength: 14,
			DataType: 'String',
			Constraint:
				'Mandatory (except for cases of issuing electronic invoices with codes that do not collect money on the electronic information portal of the tax authority)',
			IsTitle: false,
			PathRoot: 'Tag HDon\\DLHDon\\TTChung'
		},
		{
			TargetName: 'Taxpayer Identification Number (TIN) of the unit authorized to issue invoices',
			TagName: 'MSTDVNUNLHDon',
			MaxLength: 14,
			DataType: 'String',
			Constraint: 'Mandatory (For cases of invoice authorization)',
			IsTitle: false,
			PathRoot: 'Tag HDon\\DLHDon\\TTChung'
		},
		{
			TargetName: 'Name of the unit authorized to issue invoices',
			TagName: 'TDVNUNLHDon',
			MaxLength: 400,
			DataType: 'String',
			Constraint: 'Mandatory (For cases of invoice authorization)',
			IsTitle: false,
			PathRoot: 'Tag HDon\\DLHDon\\TTChung'
		},
		{
			TargetName: 'Address of the unit authorized to issue invoices',
			TagName: 'DCDVNUNLHDon',
			MaxLength: 400,
			DataType: 'String',
			Constraint: 'Mandatory (For cases of invoice authorization)',
			IsTitle: false,
			PathRoot: 'Tag HDon\\DLHDon\\TTChung'
		},
		{
			TargetName:
				'Tag HDon\\DLHDon\\TTChung\\TTHDLQuan invoices contain information on related invoices in cases of adjustment or replacement invoices',
			IsTitle: true
		},
		{
			TargetName: 'Nature of the invoice',
			TagName: 'TCHDon',
			MaxLength: 1,
			DataType: 'Number (1: Replacement, 2: Adjustment)',
			Constraint: 'Mandatory',
			IsTitle: false,
			PathRoot:
				'Tag HDon\\DLHDon\\TTChung\\TTHDLQuan invoices contain information on related invoices in cases of adjustment or replacement invoices'
		},
		{
			TargetName: 'Type of related invoice (Type of replaced/adjusted invoice)',
			TagName: 'LHDCLQuan',
			MaxLength: 1,
			DataType: 'Number (Details in Appendix VI attached to Decision No. 1450/QD-TCT dated October 7, 2021)',
			Constraint: 'Mandatory',
			IsTitle: false,
			PathRoot:
				'Tag HDon\\DLHDon\\TTChung\\TTHDLQuan invoices contain information on related invoices in cases of adjustment or replacement invoices'
		},
		{
			TargetName: 'Template code of related invoice (Template code of replaced/adjusted invoice)',
			TagName: 'KHMSHDCLQuan',
			MaxLength: 11,
			DataType: 'String (Details in Section 16, Appendix attached to Decision No. 1450/QD-TCT)',
			Constraint:
				'Mandatory (For adjustment or replacement cases of invoices with Template code, Invoice code, Invoice number)',
			IsTitle: false,
			PathRoot:
				'Tag HDon\\DLHDon\\TTChung\\TTHDLQuan invoices contain information on related invoices in cases of adjustment or replacement invoices'
		},
		{
			TargetName: 'Invoice code of related invoice (Invoice code of replaced/adjusted invoice)',
			TagName: 'KHHDCLQuan',
			MaxLength: 8,
			DataType: 'String',
			Constraint:
				'Mandatory (For adjustment or replacement cases of invoices with Template code, Invoice code, Invoice number)',
			IsTitle: false,
			PathRoot:
				'Tag HDon\\DLHDon\\TTChung\\TTHDLQuan invoices contain information on related invoices in cases of adjustment or replacement invoices'
		},
		{
			TargetName: 'Invoice number of related invoice (Invoice number of replaced/adjusted invoice)',
			TagName: 'SHDCLQuan',
			MaxLength: 8,
			DataType: 'String',
			Constraint:
				'Mandatory (For adjustment or replacement cases of invoices with Template code, Invoice code, Invoice number)',
			IsTitle: false,
			PathRoot:
				'Tag HDon\\DLHDon\\TTChung\\TTHDLQuan invoices contain information on related invoices in cases of adjustment or replacement invoices'
		},
		{
			TargetName: 'Date of related invoice (Date of replaced/adjusted invoice)',
			TagName: 'NLHDCLQuan',
			DataType: 'Date',
			Constraint: 'Mandatory',
			IsTitle: false,
			PathRoot:
				'Tag HDon\\DLHDon\\TTChung\\TTHDLQuan invoices contain information on related invoices in cases of adjustment or replacement invoices'
		},
		{
			TargetName: 'Note',
			TagName: 'GChu',
			MaxLength: 255,
			DataType: 'String',
			Constraint: 'Not mandatory',
			IsTitle: false,
			PathRoot:
				'Tag HDon\\DLHDon\\TTChung\\TTHDLQuan invoices contain information on related invoices in cases of adjustment or replacement invoices'
		},
		{
			TargetName: 'Tag HDon\\DLHDon\\NDHDon\\NBan',
			IsTitle: true
		},
		{
			TargetName: 'Name',
			TagName: 'Ten',
			MaxLength: 400,
			DataType: 'String',
			Constraint: 'Mandatory',
			IsTitle: false,
			PathRoot: 'Tag Hdon\\DLHDon\\NDHDon\\NBan'
		},
		{
			TargetName: 'Tax code',
			TagName: 'MST',
			MaxLength: 14,
			DataType: 'String',
			Constraint: 'Mandatory',
			IsTitle: false,
			PathRoot: 'Tag Hdon\\DLHDon\\NDHDon\\NBan'
		},
		{
			TargetName: 'Address',
			TagName: 'DChi',
			MaxLength: 400,
			DataType: 'String',
			Constraint: 'Mandatory',
			IsTitle: false,
			PathRoot: 'Tag Hdon\\DLHDon\\NDHDon\\NBan'
		},
		{
			TargetName: 'Phone number',
			TagName: 'SDThoai',
			MaxLength: 20,
			DataType: 'String',
			Constraint: 'Not mandatory',
			IsTitle: false,
			PathRoot: 'Tag Hdon\\DLHDon\\NDHDon\\NBan'
		},
		{
			TargetName: 'Email address',
			TagName: 'DCTDTu',
			MaxLength: 50,
			DataType: 'String',
			Constraint: 'Not mandatory',
			IsTitle: false,
			PathRoot: 'Tag Hdon\\DLHDon\\NDHDon\\NBan'
		},
		{
			TargetName: 'Bank account number',
			TagName: 'STKNHang',
			MaxLength: 30,
			DataType: 'String',
			Constraint: 'Not mandatory',
			IsTitle: false,
			PathRoot: 'Tag Hdon\\DLHDon\\NDHDon\\NBan'
		},
		{
			TargetName: 'Bank name',
			TagName: 'TNHang',
			MaxLength: 400,
			DataType: 'String',
			Constraint: 'Not mandatory',
			IsTitle: false,
			PathRoot: 'Tag Hdon\\DLHDon\\NDHDon\\NBan'
		},
		{
			TargetName: 'Fax',
			TagName: 'Fax',
			MaxLength: 20,
			DataType: 'String',
			Constraint: 'Not mandatory',
			IsTitle: false,
			PathRoot: 'Tag Hdon\\DLHDon\\NDHDon\\NBan'
		},
		{
			TargetName: 'Website',
			TagName: 'Website',
			MaxLength: 100,
			DataType: 'String',
			Constraint: 'Not mandatory',
			IsTitle: false,
			PathRoot: 'Tag Hdon\\DLHDon\\NDHDon\\NBan'
		},
		{
			TargetName: 'Tag HDon\\DLHDon\\NDHDon\\NMua',
			IsTitle: true
		},
		{
			TargetName: 'Name',
			TagName: 'Ten',
			MaxLength: 400,
			DataType: 'String',
			Constraint: 'Mandatory (if available)',
			IsTitle: false,
			PathRoot: 'Tag HDon\\DLHDon\\NDHDon\\NMua'
		},
		{
			TargetName: 'Tax code',
			TagName: 'MST',
			MaxLength: 14,
			DataType: 'String',
			Constraint: 'Mandatory (if available)',
			IsTitle: false,
			PathRoot: 'Tag HDon\\DLHDon\\NDHDon\\NMua'
		},
		{
			TargetName: 'Budget relationship unit code',
			TagName: 'MDVQHNSach',
			MaxLength: 7,
			DataType: 'String',
			Constraint: 'Not mandatory',
			IsTitle: false,
			PathRoot: 'Tag HDon\\DLHDon\\NDHDon\\NMua'
		},
		{
			TargetName: 'Address',
			TagName: 'DChi',
			MaxLength: 400,
			DataType: 'String',
			Constraint: 'Mandatory (if available)',
			IsTitle: false,
			PathRoot: 'Tag HDon\\DLHDon\\NDHDon\\NMua'
		},
		{
			TargetName: 'Customer code',
			TagName: 'MKHang',
			MaxLength: 50,
			DataType: 'String',
			Constraint: 'Not mandatory',
			IsTitle: false,
			PathRoot: 'Tag HDon\\DLHDon\\NDHDon\\NMua'
		},
		{
			TargetName: 'Citizenship ID',
			TagName: 'CCCDan',
			MaxLength: 12,
			DataType: 'String',
			Constraint: 'Mandatory (if available)',
			IsTitle: false,
			PathRoot: 'Tag HDon\\DLHDon\\NDHDon\\NMua'
		},
		{
			TargetName: 'Passport number',
			TagName: 'SHChieu',
			MaxLength: 20,
			DataType: 'String',
			Constraint: 'Mandatory (if available)',
			IsTitle: false,
			PathRoot: 'Thẻ Hdon\\DLHDon\\NDHDon\\NMua'
		},
		{
			TargetName: 'Phone number',
			TagName: 'SDThoai',
			MaxLength: 20,
			DataType: 'String',
			Constraint: 'Not mandatory',
			IsTitle: false,
			PathRoot: 'Tag HDon\\DLHDon\\NDHDon\\NMua'
		},
		{
			TargetName: 'Email address',
			TagName: 'DCTDTu',
			MaxLength: 50,
			DataType: 'String',
			Constraint: 'Not mandatory',
			IsTitle: false,
			PathRoot: 'Tag HDon\\DLHDon\\NDHDon\\NMua'
		},
		{
			TargetName: 'Full name of buyer',
			TagName: 'HVTNMHang',
			MaxLength: 100,
			DataType: 'String',
			Constraint: 'Not mandatory',
			IsTitle: false,
			PathRoot: 'Tag HDon\\DLHDon\\NDHDon\\NMua'
		},
		{
			TargetName: 'Bank account number',
			TagName: 'STKNHang',
			MaxLength: 30,
			DataType: 'String',
			Constraint: 'Not mandatory',
			IsTitle: false,
			PathRoot: 'Tag HDon\\DLHDon\\NDHDon\\NMua'
		},
		{
			TargetName: 'Bank name',
			TagName: 'TNHang',
			MaxLength: 400,
			DataType: 'String',
			Constraint: 'Not mandatory',
			IsTitle: false,
			PathRoot: 'Tag HDon\\DLHDon\\NDHDon\\NMua'
		},
		{
			TargetName: 'Tag HDon\\DLHDon\\NDHDonVDSHHDVu\\HHDVu',
			IsTitle: true
		},
		{
			TargetName: 'Nature',
			TagName: 'TChat',
			MaxLength: 1,
			DataType: 'Number (Details in Appendix IV attached to Decision No. 1450/QD-TCT dated 7/10/2021)',
			Constraint: 'Mandatory',
			IsTitle: false,
			PathRoot: 'Tag HDon\\DLHDon\\NDHDonVDSHHDVu\\HHDVu'
		},
		{
			TargetName: 'No.',
			TagName: 'STT',
			MaxLength: 4,
			DataType: 'Number',
			Constraint: 'Not mandatory',
			IsTitle: false,
			PathRoot: 'Tag HDon\\DLHDon\\NDHDonVDSHHDVu\\HHDVu'
		},
		{
			TargetName: 'Product, service code',
			TagName: 'MHHDVu',
			MaxLength: 50,
			DataType: 'String',
			Constraint: 'Mandatory (if available)',
			IsTitle: false,
			PathRoot: 'Tag HDon\\DLHDon\\NDHDonVDSHHDVu\\HHDVu'
		},
		{
			TargetName: 'Product, service name',
			TagName: 'THHDVu',
			MaxLength: 500,
			DataType: 'String',
			Constraint: 'Mandatory',
			IsTitle: false,
			PathRoot: 'Tag HDon\\DLHDon\\NDHDonVDSHHDVu\\HHDVu'
		},
		{
			TargetName: 'Unit',
			TagName: 'DVTinh',
			MaxLength: 50,
			DataType: 'String',
			Constraint: 'Mandatory (if available)',
			IsTitle: false,
			PathRoot: 'Tag HDon\\DLHDon\\NDHDonVDSHHDVu\\HHDVu'
		},
		{
			TargetName: 'Quantity',
			TagName: 'SLuong',
			MaxLength: '21.6',
			DataType: 'Number',
			Constraint: 'Mandatory (if available)',
			IsTitle: false,
			PathRoot: 'Tag HDon\\DLHDon\\NDHDonVDSHHDVu\\HHDVu'
		},
		{
			TargetName: 'Unit price',
			TagName: 'DGia',
			MaxLength: '21.6',
			DataType: 'Number',
			Constraint: 'Mandatory (if available)',
			IsTitle: false,
			PathRoot: 'Tag HDon\\DLHDon\\NDHDonVDSHHDVu\\HHDVu'
		},
		{
			TargetName: 'Discount rate (%) (In case of showing discount information for each item or service)',
			TagName: 'TLCKhau',
			MaxLength: '6.4',
			DataType: 'Number',
			Constraint: 'Not mandatory',
			IsTitle: false,
			PathRoot: 'Tag HDon\\DLHDon\\NDHDonVDSHHDVu\\HHDVu'
		},
		{
			TargetName: 'Discount amount (In case of showing discount information for each item or service)',
			TagName: 'STCKhau',
			MaxLength: '21.6',
			DataType: 'Number',
			Constraint: 'Not mandatory',
			IsTitle: false,
			PathRoot: 'Tag HDon\\DLHDon\\NDHDonVDSHHDVu\\HHDVu'
		},
		{
			TargetName: 'Total amount (Total amount excluding VAT)',
			TagName: 'ThTien',
			MaxLength: '21.6',
			DataType: 'Number',
			Constraint: 'Mandatory (except when TChat has the value “4-Note/explanation”)',
			IsTitle: false,
			PathRoot: 'Tag HDon\\DLHDon\\NDHDonVDSHHDVu\\HHDVu'
		},
		{
			TargetName: 'Tag HDon\\DLHDon\\NDHDon\\Ttoan',
			IsTitle: true
		},
		{
			TargetName: 'Tag HDon\\DLHDon\\NDHDon\\TToan\\DSLPhi\\Lphi',
			IsTitle: true
		},
		{
			TargetName: 'Fee name',
			TagName: 'TLPhi',
			MaxLength: 100,
			DataType: 'String',
			Constraint: 'Mandatory (if available)',
			IsTitle: false,
			PathRoot: 'Tag HDon\\DLHDon\\NDHDon\\TToan\\DSLPhi\\Lphi'
		},
		{
			TargetName: 'Fee amount',
			TagName: 'TPhi',
			MaxLength: '21.6',
			DataType: 'Number',
			Constraint: 'Mandatory (if available)',
			IsTitle: false,
			PathRoot: 'Tag HDon\\DLHDon\\NDHDon\\TToan\\DSLPhi\\Lphi'
		},
		{
			TargetName: 'Items placed inside the HDon\\DLHDon\\NDHDon\\TToan tag',
			IsTitle: true
		},
		{
			TargetName: 'Total commercial discount amount',
			TagName: 'TTCKTMai',
			MaxLength: '21.6',
			DataType: 'Number',
			Constraint: 'Mandatory (if available)',
			IsTitle: false,
			PathRoot: 'Items placed inside the HDon\\DLHDon\\NDHDon\\TToan tag'
		},
		{
			TargetName: 'Other deduction total',
			TagName: 'TGTKhac',
			MaxLength: '21.6',
			DataType: 'Number',
			Constraint: 'Not mandatory',
			IsTitle: false,
			PathRoot: 'Items placed inside the HDon\\DLHDon\\NDHDon\\TToan tag'
		},
		{
			TargetName: 'Total payment amount in numbers',
			TagName: 'TgTTTBSo',
			MaxLength: '21.6',
			DataType: 'Number',
			Constraint: 'Mandatory',
			IsTitle: false,
			PathRoot: 'Items placed inside the HDon\\DLHDon\\NDHDon\\TToan tag'
		},
		{
			TargetName: 'Total payment amount in words',
			TagName: 'TgTTTBChu',
			MaxLength: 255,
			DataType: 'String',
			Constraint: 'Mandatory',
			IsTitle: false,
			PathRoot: 'Items placed inside the HDon\\DLHDon\\NDHDon\\TToan tag'
		},
		{
			TargetName: 'HDon\\DLQRCode contains QR Code data',
			IsTitle: true
		},
		{
			TargetName: 'QR Code data',
			TagNameCheck: 'DLQRCode',
			MaxLength: 512,
			DataType: 'String',
			Constraint: 'Not mandatory',
			IsTitle: false,
			PathRoot: 'HDon\\DLQRCode contains QR Code data'
		},
		{
			TargetName:
				'For invoices with codes, if conditions are met to issue codes, the tax authority system returns the item Tax authority code on electronic invoices (MCCQT tag, placed inside the HDon tag)',
			IsTitle: true
		},
		{
			TargetName: 'Tax authority code',
			TagName: 'MCCQT',
			MaxLength: 34,
			DataType: 'String',
			Constraint: 'Mandatory',
			IsTitle: false,
			PathRoot:
				'For invoices with codes, if conditions are met to issue codes, the tax authority system returns the item Tax authority code on electronic invoices (MCCQT tag, placed inside the HDon tag)'
		},
		{
			TargetName: 'Tag HDon\\DSCKS\\NBan',
			IsTitle: true
		},
		{
			TargetName: "Seller's digital signature",
			TagName: 'Signature',
			Constraint: 'Mandatory (if available)',
			IsTitle: false,
			PathRoot: 'Tag Hdon\\DSCKS\\NBan'
		},
		{
			TargetName: 'Tag Hdon\\DSCKS\\NMua',
			IsTitle: true
		},
		{
			TargetName: 'Digital signature of the buyer',
			TagName: 'Signature',
			Constraint: 'Not mandatory',
			IsTitle: false,
			PathRoot: 'Tag Hdon\\DSCKS\\NMua'
		},
		{
			TargetName:
				'For electronic invoices eligible for code issuance, the tax authority system returns the electronic invoice and adds the CQT tag (placed inside the HDonXDSCKS tag) containing the digital signature information of the tax authority (signed on the HDon\\DLHDon tag, MCCQT tag, and HDon\\DSCKS\\CQT\\Signature\\Object tag)',
			IsTitle: true
		},
		{
			TargetName: 'Digital signature of the tax authority',
			TagName: 'Signature',
			Constraint: 'Mandatory',
			IsTitle: false,
			PathRoot:
				'For electronic invoices eligible for code issuance, the tax authority system returns the electronic invoice and adds the CQT tag (placed inside the HDonXDSCKS tag) containing the digital signature information of the tax authority (signed on the HDon\\DLHDon tag, MCCQT tag, and HDon\\DSCKS\\CQT\\Signature\\Object tag)'
		}
	],

	formatXMLMTT: [
		{
			TargetName: 'Tag Hdon\\DLHDon\\TTChung',
			IsTitle: true
		},
		{
			TargetName: 'XML version',
			TagName: 'PBan',
			MaxLength: 6,
			DataType: 'String',
			Constraint: 'Mandatory',
			IsTitle: false,
			PathRoot: 'Tag Hdon\\DLHDon\\TTChung'
		},
		{
			TargetName: 'Invoice name',
			TagName: 'THDon',
			MaxLength: 100,
			DataType: 'String',
			Constraint: 'Mandatory (if available)',
			IsTitle: false,
			PathRoot: 'Tag Hdon\\DLHDon\\TTChung'
		},
		{
			TargetName: 'Pattern serial number of the invoice',
			TagName: 'KHMSHDon',
			MaxLength: 1,
			DataType: 'String (Details in Appendix 16 attached to Decision No. 1450/QD-TCT)',
			Constraint: 'Mandatory (if available)',
			IsTitle: false,
			PathRoot: 'Tag Hdon\\DLHDon\\TTChung'
		},
		{
			TargetName: 'Invoice symbol',
			TagName: 'KHHDon',
			MaxLength: 6,
			DataType: 'String',
			Constraint: 'Mandatory (if available)',
			IsTitle: false,
			PathRoot: 'Tag Hdon\\DLHDon\\TTChung'
		},
		{
			TargetName: 'Invoice number',
			TagName: 'SHDon',
			MaxLength: 8,
			DataType: 'Number',
			Constraint: 'Mandatory (if available)',
			IsTitle: false,
			PathRoot: 'Tag Hdon\\DLHDon\\TTChung'
		},
		{
			TargetName: 'Date of issuance',
			TagName: 'NLap',
			DataType: 'Date',
			Constraint: 'Mandatory',
			IsTitle: false,
			PathRoot: 'Tag Hdon\\DLHDon\\TTChung'
		},
		{
			TargetName:
				'Tag Hdon\\DLHDon\\TTChung\\TTHDLQuan invoices contain information on related invoices in cases of adjustment or replacement invoices',
			IsTitle: true
		},
		{
			TargetName: 'Nature of the invoice',
			TagName: 'TCHDon',
			MaxLength: 1,
			DataType: 'Number (1: Replacement, 2: Adjustment)',
			Constraint: 'Mandatory',
			IsTitle: false,
			PathRoot:
				'Tag Hdon\\DLHDon\\TTChung\\TTHDLQuan invoices contain information on related invoices in cases of adjustment or replacement invoices'
		},
		{
			TargetName: 'Type of related invoice (Type of replaced/adjusted invoice)',
			TagName: 'LHDCLQuan',
			MaxLength: 1,
			DataType: 'Number (Details in Appendix VI attached to Decision No. 1450/QD-TCT dated October 7, 2021)',
			Constraint: 'Mandatory',
			IsTitle: false,
			PathRoot:
				'Tag Hdon\\DLHDon\\TTChung\\TTHDLQuan invoices contain information on related invoices in cases of adjustment or replacement invoices'
		},
		{
			TargetName: 'Template code of related invoice (Template code of replaced/adjusted invoice)',
			TagName: 'KHMSHDCLQuan',
			MaxLength: 11,
			DataType: 'String (Details in Section 16, Appendix attached to Decision No. 1450/QD-TCT)',
			Constraint: 'Mandatory',
			IsTitle: false,
			PathRoot:
				'Tag Hdon\\DLHDon\\TTChung\\TTHDLQuan invoices contain information on related invoices in cases of adjustment or replacement invoices'
		},
		{
			TargetName: 'Invoice code of related invoice (Invoice code of replaced/adjusted invoice)',
			TagName: 'KHHDCLQuan',
			MaxLength: 8,
			DataType: 'String',
			Constraint: 'Mandatory',
			IsTitle: false,
			PathRoot:
				'Tag Hdon\\DLHDon\\TTChung\\TTHDLQuan invoices contain information on related invoices in cases of adjustment or replacement invoices'
		},
		{
			TargetName: 'Invoice number of related invoice (Invoice number of replaced/adjusted invoice)',
			TagName: 'SHDCLQuan',
			MaxLength: 8,
			DataType: 'String',
			Constraint: 'Mandatory',
			IsTitle: false,
			PathRoot:
				'Tag Hdon\\DLHDon\\TTChung\\TTHDLQuan invoices contain information on related invoices in cases of adjustment or replacement invoices'
		},
		{
			TargetName: 'Date of related invoice (Date of replaced/adjusted invoice)',
			TagName: 'NLHDCLQuan',
			DataType: 'Date',
			Constraint: 'Mandatory',
			IsTitle: false,
			PathRoot:
				'Tag Hdon\\DLHDon\\TTChung\\TTHDLQuan invoices contain information on related invoices in cases of adjustment or replacement invoices'
		},
		{
			TargetName: 'Tag HDon\\DLHDon\\NDHDon\\NBan',
			IsTitle: true
		},
		{
			TargetName: 'Name',
			TagName: 'Ten',
			MaxLength: 400,
			DataType: 'String',
			Constraint: 'Mandatory',
			IsTitle: false,
			PathRoot: 'Tag Hdon\\DLHDon\\NDHDon\\NBan'
		},
		{
			TargetName: 'Tax code',
			TagName: 'MST',
			MaxLength: 14,
			DataType: 'String',
			Constraint: 'Mandatory',
			IsTitle: false,
			PathRoot: 'Tag Hdon\\DLHDon\\NDHDon\\NBan'
		},
		{
			TargetName: 'Address',
			TagName: 'DChi',
			MaxLength: 400,
			DataType: 'String',
			Constraint: 'Mandatory',
			IsTitle: false,
			PathRoot: 'Tag Hdon\\DLHDon\\NDHDon\\NBan'
		},
		{
			TargetName: 'Phone number',
			TagName: 'SDThoai',
			MaxLength: 20,
			DataType: 'String',
			Constraint: 'Not mandatory',
			IsTitle: false,
			PathRoot: 'Tag Hdon\\DLHDon\\NDHDon\\NBan'
		},
		{
			TargetName: 'Tag HDon\\DLHDon\\NDHDon\\NMua',
			IsTitle: true
		},
		{
			TargetName: 'Full name of buyer',
			TagName: 'HVTNMHang',
			MaxLength: 100,
			DataType: 'String',
			Constraint: 'Not mandatory',
			IsTitle: false,
			PathRoot: 'Tag HDon\\DLHDon\\NDHDon\\NMua'
		},
		{
			TargetName: 'Name',
			TagName: 'Ten',
			MaxLength: 400,
			DataType: 'String',
			Constraint: 'Not mandatory',
			IsTitle: false,
			PathRoot: 'Tag HDon\\DLHDon\\NDHDon\\NMua'
		},
		{
			TargetName: 'Tax code',
			TagName: 'MST',
			MaxLength: 14,
			DataType: 'String',
			Constraint: 'Not mandatory',
			IsTitle: false,
			PathRoot: 'Tag HDon\\DLHDon\\NDHDon\\NMua'
		},
		{
			TargetName: 'Budget relationship unit code',
			TagName: 'MDVQHNSach',
			MaxLength: 7,
			DataType: 'String',
			Constraint: 'Not mandatory',
			IsTitle: false,
			PathRoot: 'Tag HDon\\DLHDon\\NDHDon\\NMua'
		},
		{
			TargetName: 'Address',
			TagName: 'DChi',
			MaxLength: 400,
			DataType: 'String',
			Constraint: 'Not mandatory',
			IsTitle: false,
			PathRoot: 'Tag HDon\\DLHDon\\NDHDon\\NMua'
		},
		{
			TargetName: 'Citizenship ID',
			TagName: 'CCCDan',
			MaxLength: 12,
			DataType: 'String',
			Constraint: 'Mandatory (if available)',
			IsTitle: false,
			PathRoot: 'Tag HDon\\DLHDon\\NDHDon\\NMua'
		},
		{
			TargetName: 'Passport number',
			TagName: 'SHChieu',
			MaxLength: 20,
			DataType: 'String',
			Constraint: 'Mandatory (if available)',
			IsTitle: false,
			PathRoot: 'Thẻ Hdon\\DLHDon\\NDHDon\\NMua'
		},
		{
			TargetName: 'Phone number',
			TagName: 'SDThoai',
			MaxLength: 20,
			DataType: 'String',
			Constraint: 'Not mandatory',
			IsTitle: false,
			PathRoot: 'Tag HDon\\DLHDon\\NDHDon\\NMua'
		},
		{
			TargetName: 'Tag HDon\\DLHDon\\NDHDon\\DSHHDVu',
			IsTitle: true
		},
		{
			TargetName: 'Nature',
			TagName: 'TChat',
			MaxLength: 1,
			DataType: 'Number (Details in Appendix IV attached to Decision No. 1450/QD-TCT dated 7/10/2021)',
			Constraint: 'Mandatory',
			IsTitle: false,
			PathRoot: 'Tag HDon\\DLHDon\\NDHDon\\DSHHDVu'
		},
		{
			TargetName: 'No.',
			TagName: 'STT',
			MaxLength: 4,
			DataType: 'Number',
			Constraint: 'Not mandatory',
			IsTitle: false,
			PathRoot: 'Tag HDon\\DLHDon\\NDHDon\\DSHHDVu'
		},
		{
			TargetName: 'Product, service code',
			TagName: 'MHHDVu',
			MaxLength: 50,
			DataType: 'String',
			Constraint: 'Mandatory (if available)',
			IsTitle: false,
			PathRoot: 'Tag HDon\\DLHDon\\NDHDon\\DSHHDVu'
		},
		{
			TargetName: 'Product, service name',
			TagName: 'THHDVu',
			MaxLength: 500,
			DataType: 'String',
			Constraint: 'Mandatory',
			IsTitle: false,
			PathRoot: 'Tag HDon\\DLHDon\\NDHDon\\DSHHDVu'
		},
		{
			TargetName: 'Unit',
			TagName: 'DVTinh',
			MaxLength: 50,
			DataType: 'String',
			Constraint: 'Mandatory (if available)',
			IsTitle: false,
			PathRoot: 'Tag HDon\\DLHDon\\NDHDon\\DSHHDVu'
		},
		{
			TargetName: 'Quantity',
			TagName: 'SLuong',
			MaxLength: '21.6',
			DataType: 'Number',
			Constraint: 'Mandatory (if available)',
			IsTitle: false,
			PathRoot: 'Tag HDon\\DLHDon\\NDHDon\\DSHHDVu'
		},
		{
			TargetName: 'Unit price',
			TagName: 'DGia',
			MaxLength: '21.6',
			DataType: 'Number',
			Constraint: 'Mandatory (if available)',
			IsTitle: false,
			PathRoot: 'Tag HDon\\DLHDon\\NDHDon\\DSHHDVu'
		},
		{
			TargetName: 'Discount rate (%) (In case of showing discount information for each item or service)',
			TagName: 'TLCKhau',
			MaxLength: '6.4',
			DataType: 'Number',
			Constraint: 'Not mandatory',
			IsTitle: false,
			PathRoot: 'Tag Hdon\\DLHDon\\NDHDon\\DSHHDVu'
		},
		{
			TargetName: 'Discount amount (In case of showing discount information for each item or service)',
			TagName: 'STCKhau',
			MaxLength: '21.6',
			DataType: 'Number',
			Constraint: 'Not mandatory',
			IsTitle: false,
			PathRoot: 'Tag Hdon\\DLHDon\\NDHDon\\DSHHDVu'
		},
		{
			TargetName: 'Total amount (Total amount excluding VAT)',
			TagName: 'ThTien',
			MaxLength: '21.6',
			DataType: 'Number',
			Constraint: 'Mandatory (except when TChat has the value “4-Note/explanation”)',
			IsTitle: false,
			PathRoot: 'Tag Hdon\\DLHDon\\NDHDon\\DSHHDVu'
		},
		{
			TargetName: 'Tax rate (VAT tax rate)',
			TagName: 'TSuat',
			MaxLength: 11,
			DataType: 'String (Details in Section 17 of the Appendix attached to Decision No. 1450/QD-TCT)',
			Constraint: 'Mandatory (if available)',
			IsTitle: false,
			PathRoot: 'Tag Hdon\\DLHDon\\NDHDon\\DSHHDVu'
		},
		{
			TargetName: 'Tag HdonVDLHDon\\NDHDon\\TToan\\THTTLTSuat\\LTSuat',
			IsTitle: true
		},
		{
			TargetName: 'Tax rate (VAT tax rate)',
			TagName: 'TSuat',
			MaxLength: 11,
			DataType: 'String (Details in Section 17 of the Appendix attached to Decision No. 1450/QD-TCT)',
			Constraint: 'Mandatory (if available)',
			IsTitle: false,
			PathRoot: 'Tag HDon\\DLHDon\\NDHDon\\TToan\\THTTLTSuat'
		},
		{
			TargetName: 'Total amount (Total amount excluding VAT)',
			TagName: 'ThTien',
			MaxLength: '21.6',
			DataType: 'Number',
			Constraint: 'Mandatory',
			IsTitle: false,
			PathRoot: 'Tag HDon\\DLHDon\\NDHDon\\TToan\\THTTLTSuat'
		},
		{
			TargetName: 'Total amount (Total amount excluding VAT)',
			TagName: 'ThTien',
			MaxLength: '21.6',
			DataType: 'Number',
			Constraint: 'Mandatory',
			IsTitle: false,
			PathRoot: 'Tag HDon\\DLHDon\\NDHDon\\TToan\\THTTLTSuat'
		},
		{
			TargetName: 'Tax amount (VAT tax amount)',
			TagName: 'TThue',
			MaxLength: '21.6',
			DataType: 'Number',
			Constraint: 'Mandatory (if available)',
			IsTitle: false,
			PathRoot: 'Tag HDon\\DLHDon\\NDHDon\\TToan\\THTTLTSuat'
		},
		{
			TargetName: 'Tag HDon\\DLHDon\\NDHDon\\TToan',
			IsTitle: true
		},
		{
			TargetName: 'Total amount excluding tax (Total amount excluding VAT)',
			TagName: 'TgTCThue',
			MaxLength: '21.6',
			DataType: 'Number',
			Constraint: 'Mandatory',
			IsTitle: false,
			PathRoot: 'Tag Hdon\\DLHDon\\NDHDon\\TToan'
		},
		{
			TargetName: 'Total tax amount (Total VAT amount)',
			TagName: 'TgTThue',
			MaxLength: '21.6',
			DataType: 'Number',
			Constraint: 'Mandatory',
			IsTitle: false,
			PathRoot: 'Tag Hdon\\DLHDon\\NDHDon\\TToan'
		},
		{
			TargetName: 'Items placed inside the HDon\\DLHDon\\NDHDon\\TToan tag',
			IsTitle: true
		},
		{
			TargetName: 'Total commercial discount amount',
			TagName: 'TTCKTMai',
			MaxLength: '21.6',
			DataType: 'Number',
			Constraint: 'Mandatory (if available)',
			IsTitle: false,
			PathRoot: 'Items placed inside the HDon\\DLHDon\\NDHDon\\TToan'
		},
		{
			TargetName: 'Total payment amount in numbers',
			TagName: 'TgTTTBSo',
			MaxLength: '21.6',
			DataType: 'Number',
			Constraint: 'Mandatory',
			IsTitle: false,
			PathRoot: 'Items placed inside the HDon\\DLHDon\\NDHDon\\TToan'
		},
		{
			TargetName: 'Total payment amount in words',
			TagName: 'TgTTTBChu',
			MaxLength: 255,
			DataType: 'String',
			Constraint: 'Mandatory',
			IsTitle: false,
			PathRoot: 'Items placed inside the HDon\\DLHDon\\NDHDon\\TToan'
		},
		{
			TargetName: 'HDon\\DLQRCode contains QR Code data',
			IsTitle: true
		},
		{
			TargetName: 'QR Code data',
			TagNameCheck: 'DLQRCode',
			MaxLength: 512,
			DataType: 'String',
			Constraint: 'Not mandatory',
			IsTitle: false,
			PathRoot: 'HDon\\DLQRCode contains QR Code data'
		},
		{
			TargetName: 'Tag HDon\\MCCQT',
			IsTitle: true
		},
		{
			TargetName: 'Tax authority code',
			TagName: 'MCCQT',
			MaxLength: 23,
			DataType: 'String',
			Constraint: 'Mandatory',
			IsTitle: false,
			PathRoot: 'Tag HDon\\MCCQT'
		},
		{
			TargetName: 'Tag HDon\\DSCKS\\NBan',
			IsTitle: true
		},
		{
			TargetName: "Seller's digital signature",
			TagName: 'Signature',
			Constraint: 'Not mandatory',
			PathRoot: 'Tag HDon\\DSCKS\\NBan'
		}
	],

	formatXMLMTTBH: [
		{
			TargetName: 'Tag HDon\\DLHDon\\TTChung',
			IsTitle: true
		},
		{
			TargetName: 'XML version',
			TagName: 'PBan',
			MaxLength: 6,
			DataType: 'String',
			Constraint: 'Mandatory',
			IsTitle: false,
			PathRoot: 'Tag HDon\\DLHDon\\TTChung'
		},
		{
			TargetName: 'Invoice name',
			TagName: 'THDon',
			MaxLength: 100,
			DataType: 'String',
			Constraint: 'Mandatory (if available)',
			IsTitle: false,
			PathRoot: 'Tag HDon\\DLHDon\\TTChung'
		},
		{
			TargetName: 'Pattern serial number of the invoice',
			TagName: 'KHMSHDon',
			MaxLength: 1,
			DataType: 'String (Details in Appendix 16 attached to Decision No. 1450/QD-TCT)',
			Constraint: 'Mandatory (if available)',
			IsTitle: false,
			PathRoot: 'Tag HDon\\DLHDon\\TTChung'
		},
		{
			TargetName: 'Invoice symbol',
			TagName: 'KHHDon',
			MaxLength: 6,
			DataType: 'String',
			Constraint: 'Mandatory (if available)',
			IsTitle: false,
			PathRoot: 'Tag HDon\\DLHDon\\TTChung'
		},
		{
			TargetName: 'Invoice number',
			TagName: 'SHDon',
			MaxLength: 8,
			DataType: 'Number',
			Constraint: 'Mandatory (if available)',
			IsTitle: false,
			PathRoot: 'Tag HDon\\DLHDon\\TTChung'
		},
		{
			TargetName: 'Date of issue',
			TagName: 'NLap',
			DataType: 'Date',
			Constraint: 'Mandatory',
			IsTitle: false,
			PathRoot: 'Tag HDon\\DLHDon\\TTChung'
		},
		{
			TargetName:
				'Tag Hdon\\DLHDon\\TTChung\\TTHDLQuan invoices contain information on related invoices in cases of adjustment or replacement invoices',
			IsTitle: true
		},
		{
			TargetName: 'Nature of the invoice',
			TagName: 'TCHDon',
			MaxLength: 1,
			DataType: 'Number (1: Replacement, 2: Adjustment)',
			Constraint: 'Mandatory',
			IsTitle: false,
			PathRoot:
				'Tag Hdon\\DLHDon\\TTChung\\TTHDLQuan invoices contain information on related invoices in cases of adjustment or replacement invoices'
		},
		{
			TargetName: 'Type of related invoice (Type of replaced/adjusted invoice)',
			TagName: 'LHDCLQuan',
			MaxLength: 1,
			DataType: 'Number (Details in Appendix VI attached to Decision No. 1450/QD-TCT dated October 7, 2021)',
			Constraint: 'Mandatory',
			IsTitle: false,
			PathRoot:
				'Tag Hdon\\DLHDon\\TTChung\\TTHDLQuan invoices contain information on related invoices in cases of adjustment or replacement invoices'
		},
		{
			TargetName: 'Template code of related invoice (Template code of replaced/adjusted invoice)',
			TagName: 'KHMSHDCLQuan',
			MaxLength: 11,
			DataType: 'String (Details in Section 16, Appendix attached to Decision No. 1450/QD-TCT)',
			Constraint:
				'Mandatory (For adjustment or replacement cases of invoices with Template code, Invoice code, Invoice number)',
			IsTitle: false,
			PathRoot:
				'Tag Hdon\\DLHDon\\TTChung\\TTHDLQuan invoices contain information on related invoices in cases of adjustment or replacement invoices'
		},
		{
			TargetName: 'Invoice code of related invoice (Invoice code of replaced/adjusted invoice)',
			TagName: 'KHHDCLQuan',
			MaxLength: 8,
			DataType: 'String',
			Constraint:
				'Mandatory (For adjustment or replacement cases of invoices with Template code, Invoice code, Invoice number)',
			IsTitle: false,
			PathRoot:
				'Tag Hdon\\DLHDon\\TTChung\\TTHDLQuan invoices contain information on related invoices in cases of adjustment or replacement invoices'
		},
		{
			TargetName: 'Invoice number of related invoice (Invoice number of replaced/adjusted invoice)',
			TagName: 'SHDCLQuan',
			MaxLength: 8,
			DataType: 'String',
			Constraint:
				'Mandatory (For adjustment or replacement cases of invoices with Template code, Invoice code, Invoice number)',
			IsTitle: false,
			PathRoot:
				'Tag Hdon\\DLHDon\\TTChung\\TTHDLQuan invoices contain information on related invoices in cases of adjustment or replacement invoices'
		},
		{
			TargetName: 'Date of related invoice (Date of replaced/adjusted invoice)',
			TagName: 'NLHDCLQuan',
			DataType: 'Date',
			Constraint: 'Mandatory',
			IsTitle: false,
			PathRoot:
				'Tag Hdon\\DLHDon\\TTChung\\TTHDLQuan invoices contain information on related invoices in cases of adjustment or replacement invoices'
		},
		{
			TargetName: 'Tag HDon\\DLHDon\\NDHDon\\Nban',
			IsTitle: true
		},
		{
			TargetName: 'Name',
			TagName: 'Ten',
			MaxLength: 400,
			DataType: 'String',
			Constraint: 'Mandatory',
			IsTitle: false,
			PathRoot: 'Tag HDon\\DLHDon\\NDHDon\\Nban'
		},
		{
			TargetName: 'Tax code',
			TagName: 'MST',
			MaxLength: 14,
			DataType: 'String',
			Constraint: 'Mandatory',
			IsTitle: false,
			PathRoot: 'Tag HDon\\DLHDon\\NDHDon\\Nban'
		},
		{
			TargetName: 'Address',
			TagName: 'DChi',
			MaxLength: 400,
			DataType: 'String',
			Constraint: 'Mandatory',
			IsTitle: false,
			PathRoot: 'Tag Hdon\\DLHDon\\NDHDon\\NBan'
		},
		{
			TargetName: 'Phone number',
			TagName: 'SDThoai',
			MaxLength: 20,
			DataType: 'String',
			Constraint: 'Not mandatory',
			IsTitle: false,
			PathRoot: 'Tag Hdon\\DLHDon\\NDHDon\\NBan'
		},
		{
			TargetName: 'Tag HDon\\DLHDon\\NDHDon\\Nmua',
			IsTitle: true
		},
		{
			TargetName: 'Full name of buyer',
			TagName: 'HVTNMHang',
			MaxLength: 100,
			DataType: 'String',
			Constraint: 'Not mandatory',
			IsTitle: false,
			PathRoot: 'Tag HDon\\DLHDon\\NDHDon\\NMua'
		},
		{
			TargetName: 'Name',
			TagName: 'Ten',
			MaxLength: 400,
			DataType: 'String',
			Constraint: 'Not mandatory',
			IsTitle: false,
			PathRoot: 'Tag HDon\\DLHDon\\NDHDon\\Nmua'
		},
		{
			TargetName: 'Tax code',
			TagName: 'MST',
			MaxLength: 14,
			DataType: 'String',
			Constraint: 'Not mandatory',
			IsTitle: false,
			PathRoot: 'Tag HDon\\DLHDon\\NDHDon\\Nmua'
		},
		{
			TargetName: 'Budget relationship unit code',
			TagName: 'MDVQHNSach',
			MaxLength: 7,
			DataType: 'String',
			Constraint: 'Not mandatory',
			IsTitle: false,
			PathRoot: 'Tag HDon\\DLHDon\\NDHDon\\NMua'
		},
		{
			TargetName: 'Address',
			TagName: 'DChi',
			MaxLength: 400,
			DataType: 'String',
			Constraint: 'Not mandatory',
			IsTitle: false,
			PathRoot: 'Tag HDon\\DLHDon\\NDHDon\\Nmua'
		},
		{
			TargetName: 'Citizenship ID',
			TagName: 'CCCDan',
			MaxLength: 12,
			DataType: 'String',
			Constraint: 'Mandatory (if available)',
			IsTitle: false,
			PathRoot: 'Tag HDon\\DLHDon\\NDHDon\\NMua'
		},
		{
			TargetName: 'Passport number',
			TagName: 'SHChieu',
			MaxLength: 20,
			DataType: 'String',
			Constraint: 'Mandatory (if available)',
			IsTitle: false,
			PathRoot: 'Thẻ Hdon\\DLHDon\\NDHDon\\NMua'
		},
		{
			TargetName: 'Phone number',
			TagName: 'SDThoai',
			MaxLength: 20,
			DataType: 'String',
			Constraint: 'Not mandatory',
			IsTitle: false,
			PathRoot: 'Tag HDon\\DLHDon\\NDHDon\\Nmua'
		},
		{
			TargetName: 'Tag HDon\\DLHDon\\NDHDon\\DSHHDVu\\HHDVu',
			IsTitle: true
		},
		{
			TargetName: 'Nature',
			TagName: 'TChat',
			MaxLength: 1,
			DataType: 'Number (Details in Appendix IV attached to Decision No. 1450/QD-TCT dated 7/10/2021)',
			Constraint: 'Manadatory',
			IsTitle: false,
			PathRoot: 'Tag HDon\\DLHDon\\NDHDon\\DSHHDVu\\HHDVu'
		},
		{
			TargetName: 'No.',
			TagName: 'STT',
			MaxLength: 4,
			DataType: 'Number',
			Constraint: 'Not mandatory',
			IsTitle: false,
			PathRoot: 'Tag HDon\\DLHDon\\NDHDon\\DSHHDVu\\HHDVu'
		},
		{
			TargetName: 'Product, service code',
			TagName: 'MHHDVu',
			MaxLength: 50,
			DataType: 'String',
			Constraint: 'Mandatory (if available)',
			IsTitle: false,
			PathRoot: 'Tag HDon\\DLHDon\\NDHDon\\DSHHDVu\\HHDVu'
		},
		{
			TargetName: 'Product, service name',
			TagName: 'THHDVu',
			MaxLength: 500,
			DataType: 'String',
			Constraint: 'Mandatory',
			IsTitle: false,
			PathRoot: 'Tag HDon\\DLHDon\\NDHDon\\DSHHDVu\\HHDVu'
		},
		{
			TargetName: 'Unit',
			TagName: 'DVTinh',
			MaxLength: 50,
			DataType: 'String',
			Constraint: 'Mandatory (if available)',
			IsTitle: false,
			PathRoot: 'Tag HDon\\DLHDon\\NDHDon\\DSHHDVu\\HHDVu'
		},
		{
			TargetName: 'Quantity',
			TagName: 'SLuong',
			MaxLength: '21.6',
			DataType: 'Number',
			Constraint: 'Mandatory (if available)',
			IsTitle: false,
			PathRoot: 'Tag HDon\\DLHDon\\NDHDon\\DSHHDVu\\HHDVu'
		},
		{
			TargetName: 'Unit price',
			TagName: 'DGia',
			MaxLength: '21.6',
			DataType: 'Number',
			Constraint: 'Mandatory (if available)',
			IsTitle: false,
			PathRoot: 'Tag HDon\\DLHDon\\NDHDon\\DSHHDVu\\HHDVu'
		},
		{
			TargetName: 'Discount rate (%) (In case of showing discount information for each item or service)',
			TagName: 'TLCKhau',
			MaxLength: '6.4',
			DataType: 'Number',
			Constraint: 'Not mandatory',
			IsTitle: false,
			PathRoot: 'Tag HDon\\DLHDon\\NDHDon\\DSHHDVu\\HHDVu'
		},
		{
			TargetName: 'Discount amount (In case of showing discount information for each item or service)',
			TagName: 'STCKhau',
			MaxLength: '21.6',
			DataType: 'Number',
			Constraint: 'Not mandatory',
			IsTitle: false,
			PathRoot: 'Tag HDon\\DLHDon\\NDHDon\\DSHHDVu\\HHDVu'
		},
		{
			TargetName: 'Total amount',
			TagName: 'ThTien',
			MaxLength: '21.6',
			DataType: 'Number',
			Constraint: 'Mandatory (except when TChat has the value “4-Note/explanation”)',
			IsTitle: false,
			PathRoot: 'Tag HDon\\DLHDon\\NDHDon\\DSHHDVu\\HHDVu'
		},
		{
			TargetName: 'Tag HDon\\DLHDon\\NDHDon\\Ttoan',
			IsTitle: true
		},
		{
			TargetName: 'Total commercial discount amount',
			TagName: 'TTCKTMai',
			MaxLength: '21.6',
			DataType: 'Số',
			Constraint: 'Manadatory (if available)',
			IsTitle: false,
			PathRoot: 'Tag HDon\\DLHDon\\NDHDon\\Ttoan'
		},
		{
			TargetName: 'Total payment amount in numbers',
			TagName: 'TgTTTBSo',
			MaxLength: '21.6',
			DataType: 'Number',
			Constraint: 'Mandatory',
			IsTitle: false,
			PathRoot: 'Tag HDon\\DLHDon\\NDHDon\\Ttoan'
		},
		{
			TargetName: 'Total payment amount in words',
			TagName: 'TgTTTBChu',
			MaxLength: 255,
			DataType: 'String',
			Constraint: 'Mandatory',
			IsTitle: false,
			PathRoot: 'Tag HDon\\DLHDon\\NDHDon\\Ttoan'
		},
		{
			TargetName: 'HDon\\DLQRCode contains QR Code data',
			IsTitle: true
		},
		{
			TargetName: 'QR Code data',
			TagNameCheck: 'DLQRCode',
			MaxLength: 512,
			DataType: 'String',
			Constraint: 'Not mandatory',
			IsTitle: false,
			PathRoot: 'HDon\\DLQRCode contains QR Code data'
		},
		{
			TargetName: 'Tag HDon\\MCCQT',
			IsTitle: true
		},
		{
			TargetName: 'Tax authority code',
			TagName: 'MCCQT',
			MaxLength: 23,
			DataType: 'String',
			Constraint: 'Mandatory',
			IsTitle: false,
			PathRoot: 'Tag HDon\\MCCQT'
		},
		{
			TargetName: 'Tag HDon\\DSCKS\\Nban',
			IsTitle: true
		},
		{
			TargetName: "Seller's digital signature",
			TagName: 'Signature',
			Constraint: 'Not mandatory',
			IsTitle: false,
			PathRoot: 'Tag HDon\\DSCKS\\Nban'
		}
	],

	formatXMLValueAddedTicket: [
		{
			TargetName: 'Tag HDon\\DLHDon\\TTChung',
			IsTitle: true
		},
		{
			TargetName: 'XML version',
			TagName: 'PBan',
			MaxLength: 6,
			DataType: 'String',
			Constraint: 'Mandatory',
			IsTitle: false,
			PathRoot: 'Tag HDon\\DLHDon\\TTChung'
		},
		{
			TargetName: 'Invoice name',
			TagName: 'THDon',
			MaxLength: 100,
			DataType: 'String',
			Constraint: 'Mandatory (if available)',
			IsTitle: false,
			PathRoot: 'Tag Hdon\\DLHDon\\TTChung'
		},
		{
			TargetName: 'Pattern serial number of the invoice',
			TagName: 'KHMSHDon',
			MaxLength: 1,
			DataType: 'String (Details in Appendix 16 attached to Decision No. 1450/QD-TCT)',
			Constraint: 'Mandatory (if available)',
			IsTitle: false,
			PathRoot: 'Tag HDon\\DLHDon\\TTChung'
		},
		{
			TargetName: 'Invoice symbol',
			TagName: 'KHHDon',
			MaxLength: 6,
			DataType: 'String',
			Constraint: 'Mandatory (if available)',
			IsTitle: false,
			PathRoot: 'Tag HDon\\DLHDon\\TTChung'
		},
		{
			TargetName: 'Invoice number',
			TagName: 'SHDon',
			MaxLength: 8,
			DataType: 'Number',
			Constraint: 'Mandatory (if available)',
			IsTitle: false,
			PathRoot: 'Tag HDon\\DLHDon\\TTChung'
		},
		{
			TargetName: 'Date of issuance',
			TagName: 'NLap',
			DataType: 'Date',
			Constraint: 'Mandatory',
			IsTitle: false,
			PathRoot: 'Tag HDon\\DLHDon\\TTChung'
		},
		{
			TargetName: 'Currency unit',
			TagName: 'DVTTe',
			MaxLength: 3,
			DataType:
				'String (Details in Section 2, Section IV, Part I of Decision No. 1450/QD-TCT dated October 7, 2021)',
			Constraint: 'Mandatory',
			IsTitle: false,
			PathRoot: 'Tag HDon\\DLHDon\\TTChung'
		},
		{
			TargetName: 'Exchange rate',
			TagName: 'TGia',
			MaxLength: '7.2',
			DataType: 'Number',
			Constraint: 'Mandatory (Except when the Currency unit is VND)',
			IsTitle: false,
			PathRoot: 'Tag HDon\\DLHDon\\TTChung'
		},
		{
			TargetName: 'Payment method',
			TagName: 'HTTToan',
			MaxLength: 50,
			DataType: 'String',
			Constraint: 'Not mandatory',
			IsTitle: false,
			PathRoot: 'Tag HDon\\DLHDon\\TTChung'
		},
		{
			TargetName:
				'Taxpayer Identification Number (TIN) of the organization providing electronic invoice solutions',
			TagName: 'MSTTCGP',
			MaxLength: 14,
			DataType: 'String',
			Constraint:
				"Mandatory (except for cases of issuing electronic invoices with codes not collected on the tax authority's electronic portal)",
			IsTitle: false,
			PathRoot: 'Tag HDon\\DLHDon\\TTChung'
		},
		{
			TargetName: 'Taxpayer Identification Number (TIN) of the unit authorized to issue invoices',
			TagName: 'MSTDVNUNLHDon',
			MaxLength: 14,
			DataType: 'String',
			Constraint: 'Mandatory (For cases of invoice authorization)',
			IsTitle: false,
			PathRoot: 'Tag HDon\\DLHDon\\TTChung'
		},
		{
			TargetName: 'Name of the unit authorized to issue invoices',
			TagName: 'TDVNUNLHDon',
			MaxLength: 400,
			DataType: 'String',
			Constraint: 'Mandatory (For cases of invoice authorization)',
			IsTitle: false,
			PathRoot: 'Tag HDon\\DLHDon\\TTChung'
		},
		{
			TargetName: 'Address of the unit authorized to issue invoices',
			TagName: 'DCDVNUNLHDon',
			MaxLength: 400,
			DataType: 'String',
			Constraint: 'Mandatory (For cases of invoice authorization)',
			IsTitle: false,
			PathRoot: 'Tag HDon\\DLHDon\\TTChung'
		},
		{
			TargetName:
				'Tag HDon\\DLHDon\\TTChung\\TTHDLQuan invoices contain information on related invoices in cases of adjustment or replacement invoices',
			IsTitle: true,
			PathRoot: 'Tag HDon\\DLHDon\\TTChung'
		},
		{
			TargetName: 'Nature of the invoice',
			TagName: 'TCHDon',
			MaxLength: 1,
			DataType: 'Number (1: Replacement, 2: Adjustment)',
			Constraint: 'Mandatory',
			IsTitle: false,
			PathRoot:
				'Tag HDon\\DLHDon\\TTChung\\TTHDLQuan invoices contain information on related invoices in cases of adjustment or replacement invoices'
		},
		{
			TargetName: 'Type of related invoice (Type of replaced/adjusted invoice)',
			TagName: 'LHDCLQuan',
			MaxLength: 1,
			DataType: 'Number (Details in Appendix VI attached to Decision No. 1450/QD-TCT dated October 7, 2021)',
			Constraint: 'Mandatory',
			IsTitle: false,
			PathRoot:
				'Tag HDon\\DLHDon\\TTChung\\TTHDLQuan invoices contain information on related invoices in cases of adjustment or replacement invoices'
		},
		{
			TargetName: 'Template code of related invoice (Template code of replaced/adjusted invoice)',
			TagName: 'KHMSHDCLQuan',
			MaxLength: 11,
			DataType: 'String (Details in Section 16, Appendix attached to Decision No. 1450/QD-TCT)',
			Constraint:
				'Mandatory (For adjustment or replacement cases of invoices with Template code, Invoice code, Invoice number)',
			IsTitle: false,
			PathRoot:
				'Tag HDon\\DLHDon\\TTChung\\TTHDLQuan invoices contain information on related invoices in cases of adjustment or replacement invoices'
		},
		{
			TargetName: 'Invoice code of related invoice (Invoice code of replaced/adjusted invoice)',
			TagName: 'KHHDCLQuan',
			MaxLength: 8,
			DataType: 'String',
			Constraint:
				'Mandatory (For adjustment or replacement cases of invoices with Template code, Invoice code, Invoice number)',
			IsTitle: false,
			PathRoot:
				'Tag HDon\\DLHDon\\TTChung\\TTHDLQuan invoices contain information on related invoices in cases of adjustment or replacement invoices'
		},
		{
			TargetName: 'Invoice number of related invoice (Invoice number of replaced/adjusted invoice)',
			TagName: 'SHDCLQuan',
			MaxLength: 8,
			DataType: 'String',
			Constraint:
				'Mandatory (For adjustment or replacement cases of invoices with Template code, Invoice code, Invoice number)',
			IsTitle: false,
			PathRoot:
				'Tag HDon\\DLHDon\\TTChung\\TTHDLQuan invoices contain information on related invoices in cases of adjustment or replacement invoices'
		},
		{
			TargetName: 'Date of related invoice (Date of replaced/adjusted invoice)',
			TagName: 'NLHDCLQuan',
			DataType: 'Date',
			Constraint: 'Mandatory',
			IsTitle: false,
			PathRoot:
				'Tag HDon\\DLHDon\\TTChung\\TTHDLQuan invoices contain information on related invoices in cases of adjustment or replacement invoices'
		},
		{
			TargetName: 'Note',
			TagName: 'GChu',
			MaxLength: 255,
			DataType: 'String',
			Constraint: 'Not mandatory',
			IsTitle: false,
			PathRoot:
				'Tag HDon\\DLHDon\\TTChung\\TTHDLQuan invoices contain information on related invoices in cases of adjustment or replacement invoices'
		},
		{
			TargetName: 'Tag HDon\\DLHDon\\NDHDon\\Nban',
			IsTitle: true,
			PathRoot:
				'Tag HDon\\DLHDon\\TTChung\\TTHDLQuan invoices contain information on related invoices in cases of adjustment or replacement invoices'
		},
		{
			TargetName: 'Name',
			TagName: 'Ten',
			MaxLength: 400,
			DataType: 'String',
			Constraint: 'Mandatory',
			IsTitle: false,
			PathRoot: 'Tag HDon\\DLHDon\\NDHDon\\Nban'
		},
		{
			TargetName: 'Tax code',
			TagName: 'MST',
			MaxLength: 14,
			DataType: 'String',
			Constraint: 'Mandatory',
			IsTitle: false,
			PathRoot: 'Tag HDon\\DLHDon\\NDHDon\\Nban'
		},
		{
			TargetName: 'Address',
			TagName: 'DChi',
			MaxLength: 400,
			DataType: 'String',
			Constraint: 'Mandatory',
			IsTitle: false,
			PathRoot: 'Tag HDon\\DLHDon\\NDHDon\\Nban'
		},
		{
			TargetName: 'Phone number',
			TagName: 'SDThoai',
			MaxLength: 20,
			DataType: 'String',
			Constraint: 'Not mandatory',
			IsTitle: false,
			PathRoot: 'Tag HDon\\DLHDon\\NDHDon\\Nban'
		},
		{
			TargetName: 'Email address',
			TagName: 'DCTDTu',
			MaxLength: 50,
			DataType: 'String',
			Constraint: 'Not mandatory',
			IsTitle: false,
			PathRoot: 'Tag HDon\\DLHDon\\NDHDon\\Nban'
		},
		{
			TargetName: 'Bank account number',
			TagName: 'STKNHang',
			MaxLength: 30,
			DataType: 'String',
			Constraint: 'Not mandatory',
			IsTitle: false,
			PathRoot: 'Tag HDon\\DLHDon\\NDHDon\\Nban'
		},
		{
			TargetName: 'Bank name',
			TagName: 'TNHang',
			MaxLength: 400,
			DataType: 'String',
			Constraint: 'Not mandatory',
			IsTitle: false,
			PathRoot: 'Tag HDon\\DLHDon\\NDHDon\\Nban'
		},
		{
			TargetName: 'Fax',
			TagName: 'Fax',
			MaxLength: 20,
			DataType: 'String',
			Constraint: 'Not mandatory',
			IsTitle: false,
			PathRoot: 'Tag HDon\\DLHDon\\NDHDon\\Nban'
		},
		{
			TargetName: 'Website',
			TagName: 'Website',
			MaxLength: 100,
			DataType: 'String',
			Constraint: 'Not mandatory',
			IsTitle: false,
			PathRoot: 'Tag HDon\\DLHDon\\NDHDon\\Nban'
		},
		{
			TargetName: 'Tag HDon\\DLHDon\\NDHDon\\Nmua',
			IsTitle: true,
			PathRoot: 'Tag HDon\\DLHDon\\NDHDon\\Nban'
		},
		{
			TargetName: 'Name',
			TagName: 'Ten',
			MaxLength: 400,
			DataType: 'String',
			Constraint: 'Not mandatory',
			IsTitle: false,
			PathRoot: 'Tag HDon\\DLHDon\\NDHDon\\Nmua'
		},
		{
			TargetName: 'Tax code',
			TagName: 'MST',
			MaxLength: 14,
			DataType: 'String',
			Constraint: 'Not mandatory',
			IsTitle: false,
			PathRoot: 'Tag HDon\\DLHDon\\NDHDon\\Nmua'
		},
		{
			TargetName: 'Budget relationship unit code',
			TagName: 'MDVQHNSach',
			MaxLength: 7,
			DataType: 'String',
			Constraint: 'Not mandatory',
			IsTitle: false,
			PathRoot: 'Tag HDon\\DLHDon\\NDHDon\\NMua'
		},
		{
			TargetName: 'Address',
			TagName: 'DChi',
			MaxLength: 400,
			DataType: 'String',
			Constraint: 'Not mandatory',
			IsTitle: false,
			PathRoot: 'Tag HDon\\DLHDon\\NDHDon\\Nmua'
		},
		{
			TargetName: 'Customer code',
			TagName: 'MKHang',
			MaxLength: 50,
			DataType: 'String',
			Constraint: 'Not mandatory',
			IsTitle: false,
			PathRoot: 'Tag HDon\\DLHDon\\NDHDon\\Nmua'
		},
		{
			TargetName: 'Citizenship ID',
			TagName: 'CCCDan',
			MaxLength: 12,
			DataType: 'String',
			Constraint: 'Mandatory (if available)',
			IsTitle: false,
			PathRoot: 'Tag HDon\\DLHDon\\NDHDon\\NMua'
		},
		{
			TargetName: 'Passport number',
			TagName: 'SHChieu',
			MaxLength: 20,
			DataType: 'String',
			Constraint: 'Mandatory (if available)',
			IsTitle: false,
			PathRoot: 'Thẻ Hdon\\DLHDon\\NDHDon\\NMua'
		},
		{
			TargetName: 'Phone number',
			TagName: 'SDThoai',
			MaxLength: 20,
			DataType: 'String',
			Constraint: 'Not mandatory',
			IsTitle: false,
			PathRoot: 'Tag HDon\\DLHDon\\NDHDon\\Nmua'
		},
		{
			TargetName: 'Email address',
			TagName: 'DCTDTu',
			MaxLength: 50,
			DataType: 'String',
			Constraint: 'Not mandatory',
			IsTitle: false,
			PathRoot: 'Tag HDon\\DLHDon\\NDHDon\\Nmua'
		},
		{
			TargetName: 'Full name of buyer',
			TagName: 'HVTNMHang',
			MaxLength: 100,
			DataType: 'String',
			Constraint: 'Not mandatory',
			IsTitle: false,
			PathRoot: 'Tag HDon\\DLHDon\\NDHDon\\Nmua'
		},
		{
			TargetName: 'Bank account number',
			TagName: 'STKNHang',
			MaxLength: 30,
			DataType: 'String',
			Constraint: 'Not mandatory',
			IsTitle: false,
			PathRoot: 'Tag HDon\\DLHDon\\NDHDon\\Nmua'
		},
		{
			TargetName: 'Bank name',
			TagName: 'TNHang',
			MaxLength: 400,
			DataType: 'String',
			Constraint: 'Not mandatory',
			IsTitle: false,
			PathRoot: 'Tag HDon\\DLHDon\\NDHDon\\Nmua'
		},
		{
			TargetName: 'Tag HDon\\DLHDon\\NDHDon\\DSHHDVu\\HHDVu',
			IsTitle: true,
			PathRoot: 'Tag HDon\\DLHDon\\NDHDon\\Nmua'
		},
		{
			TargetName: 'Nature',
			TagName: 'TChat',
			MaxLength: 1,
			DataType: 'Number (Details in Appendix IV attached to Decision No. 1450/QD-TCT dated 7/10/2021)',
			Constraint: 'Mandatory',
			IsTitle: false,
			PathRoot: 'Tag HDon\\DLHDon\\NDHDon\\DSHHDVu\\HHDVu'
		},
		{
			TargetName: 'No.',
			TagName: 'STT',
			MaxLength: 4,
			DataType: 'Number',
			Constraint: 'Not mandatory',
			IsTitle: false,
			PathRoot: 'Tag HDon\\DLHDon\\NDHDon\\DSHHDVu\\HHDVu'
		},
		{
			TargetName: 'Product, service code',
			TagName: 'MHHDVu',
			MaxLength: 50,
			DataType: 'String',
			Constraint: 'Mandatory (if available)',
			IsTitle: false,
			PathRoot: 'Tag HDon\\DLHDon\\NDHDon\\DSHHDVu\\HHDVu'
		},
		{
			TargetName: 'Product, service name',
			TagName: 'THHDVu',
			MaxLength: 500,
			DataType: 'String',
			Constraint: 'Mandatory',
			IsTitle: false,
			PathRoot: 'Tag HDon\\DLHDon\\NDHDon\\DSHHDVu\\HHDVu'
		},
		{
			TargetName: 'Unit',
			TagName: 'DVTinh',
			MaxLength: 50,
			DataType: 'String',
			Constraint: 'Mandatory (if available)',
			IsTitle: false,
			PathRoot: 'Tag HDon\\DLHDon\\NDHDon\\DSHHDVu\\HHDVu'
		},
		{
			TargetName: 'Quantity',
			TagName: 'SLuong',
			MaxLength: '21.6',
			DataType: 'Number',
			Constraint: 'Mandatory (if available)',
			IsTitle: false,
			PathRoot: 'Tag HDon\\DLHDon\\NDHDon\\DSHHDVu\\HHDVu'
		},
		{
			TargetName: 'Unit price',
			TagName: 'DGia',
			MaxLength: '21.6',
			DataType: 'Number',
			Constraint: 'Mandatory (if available)',
			IsTitle: false,
			PathRoot: 'Tag HDon\\DLHDon\\NDHDon\\DSHHDVu\\HHDVu'
		},
		{
			TargetName: 'Discount rate (%) (In case of showing discount information for each item or service)',
			TagName: 'TLCKhau',
			MaxLength: '6.4',
			DataType: 'Number',
			Constraint: 'Not mandatory',
			IsTitle: false,
			PathRoot: 'Tag HDon\\DLHDon\\NDHDon\\DSHHDVu\\HHDVu'
		},
		{
			TargetName: 'Discount amount (In case of showing discount information for each item or service)',
			TagName: 'STCKhau',
			MaxLength: '21.6',
			DataType: 'Number',
			Constraint: 'Not mandatory',
			IsTitle: false,
			PathRoot: 'Tag HDon\\DLHDon\\NDHDon\\DSHHDVu\\HHDVu'
		},
		{
			TargetName: 'Total amount (Total amount excluding VAT)',
			TagName: 'ThTien',
			MaxLength: '21.6',
			DataType: 'Number',
			Constraint: 'Mandatory (except when TChat has the value “4-Note/explanation”)',
			IsTitle: false,
			PathRoot: 'Tag HDon\\DLHDon\\NDHDon\\DSHHDVu\\HHDVu'
		},
		{
			TargetName:
				'Tax rate (VAT rate for invoices other than VAT invoices, for invoices other than sales invoices, this tag is not available)',
			TagName: 'TSuat',
			MaxLength: 11,
			DataType: 'String (Details in Section 17 of the Appendix attached to Decision No. 1450/QD-TCT)',
			Constraint: 'Mandatory (if available)',
			IsTitle: false,
			PathRoot: 'Tag HDon\\DLHDon\\NDHDon\\DSHHDVu\\HHDVu'
		},
		{
			TargetName: 'Tag HDon\\DLHDon\\NDHDon\\TToan\\THTTLTSuat\\LTSuat',
			IsTitle: true,
			PathRoot: 'Tag HDon\\DLHDon\\NDHDon\\DSHHDVu\\HHDVu'
		},
		{
			TargetName: 'Tax rate (VAT tax rate)',
			TagName: 'TSuat',
			MaxLength: 11,
			DataType: 'String (Details in Section 17 of the Appendix attached to Decision No. 1450/QD-TCT)',
			Constraint: 'Mandatory (if available)',
			IsTitle: false,
			PathRoot: 'Tag HDon\\DLHDon\\NDHDon\\TToan\\THTTLTSuat\\LTSuat'
		},
		{
			TargetName: 'Total amount (Total amount excluding VAT)',
			TagName: 'ThTien',
			MaxLength: '21.6',
			DataType: 'Number',
			Constraint: 'Mandatory',
			IsTitle: false,
			PathRoot: 'Tag HDon\\DLHDon\\NDHDon\\TToan\\THTTLTSuat\\LTSuat'
		},
		{
			TargetName: 'Tax amount (VAT tax amount)',
			TagName: 'TThue',
			MaxLength: '21.6',
			DataType: 'Number',
			Constraint: 'Mandatory (if available)',
			IsTitle: false,
			PathRoot: 'Tag HDon\\DLHDon\\NDHDon\\TToan\\THTTLTSuat\\LTSuat'
		},
		{
			TargetName: 'Tag HDon\\DLHDon\\NDHDon\\TToan (invoices other than sales invoices do not have this tag)',
			IsTitle: true,
			PathRoot: 'Tag HDon\\DLHDon\\NDHDon\\TToan\\THTTLTSuat\\LTSuat'
		},
		{
			TargetName: 'Total amount excluding tax (Total amount excluding VAT)',
			TagName: 'TgTCThue',
			MaxLength: '21.6',
			DataType: 'Number',
			Constraint: 'Mandatory',
			IsTitle: false,
			PathRoot: 'Tag HDon\\DLHDon\\NDHDon\\TToan (invoices other than sales invoices do not have this tag)'
		},
		{
			TargetName: 'Total non-taxable deduction',
			TagName: 'TGTKCThue',
			MaxLength: '21.6',
			DataType: 'Number',
			Constraint: 'Not mandatory',
			IsTitle: false,
			PathRoot: 'Tag HDon\\DLHDon\\NDHDon\\TToan (invoices other than sales invoices do not have this tag)'
		},
		{
			TargetName: 'Total tax amount (Total VAT amount)',
			TagName: 'TgTThue',
			MaxLength: '21.6',
			DataType: 'Number',
			Constraint: 'Mandatory',
			IsTitle: false,
			PathRoot: 'Tag HDon\\DLHDon\\NDHDon\\TToan (invoices other than sales invoices do not have this tag)'
		},
		{
			TargetName: 'Tag HDon\\DLHDon\\NDHDon\\TToan\\DSLPhi\\Lphi',
			IsTitle: true,
			PathRoot: 'Tag HDon\\DLHDon\\NDHDon\\TToan (invoices other than sales invoices do not have this tag)'
		},
		{
			TargetName: 'Fee name',
			TagName: 'TLPhi',
			MaxLength: 100,
			DataType: 'String',
			Constraint: 'Mandatory (if available)',
			IsTitle: false,
			PathRoot: 'Tag HDon\\DLHDon\\NDHDon\\TToan\\DSLPhi\\Lphi'
		},
		{
			TargetName: 'Fee amount',
			TagName: 'TPhi',
			MaxLength: '21.6',
			DataType: 'Number',
			Constraint: 'Mandatory (if available)',
			IsTitle: false,
			PathRoot: 'Tag HDon\\DLHDon\\NDHDon\\TToan\\DSLPhi\\Lphi'
		},
		{
			TargetName: 'Items placed inside the HDon\\DLHDon\\NDHDon\\TToan tag',
			IsTitle: true,
			PathRoot: 'Tag HDon\\DLHDon\\NDHDon\\TToan\\DSLPhi\\Lphi'
		},
		{
			TargetName: 'Total commercial discount amount',
			TagName: 'TTCKTMai',
			MaxLength: '21.6',
			DataType: 'Number',
			Constraint: 'Mandatory (if available)',
			IsTitle: false,
			PathRoot: 'Items placed inside the HDon\\DLHDon\\NDHDon\\TToan tag'
		},
		{
			TargetName: 'Other deduction total',
			TagName: 'TGTKhac',
			MaxLength: '21.6',
			DataType: 'Number',
			Constraint: 'Not mandatory',
			IsTitle: false,
			PathRoot: 'Items placed inside the HDon\\DLHDon\\NDHDon\\TToan tag'
		},
		{
			TargetName: 'Total payment amount in numbers',
			TagName: 'TgTTTBSo',
			MaxLength: '21.6',
			DataType: 'Number',
			Constraint: 'Mandatory',
			IsTitle: false,
			PathRoot: 'Items placed inside the HDon\\DLHDon\\NDHDon\\TToan tag'
		},
		{
			TargetName: 'Total payment amount in words',
			TagName: 'TgTTTBChu',
			MaxLength: 255,
			DataType: 'String',
			Constraint: 'Mandatory',
			IsTitle: false,
			PathRoot: 'Items placed inside the HDon\\DLHDon\\NDHDon\\TToan tag'
		},
		{
			TargetName: 'HDon\\DLQRCode contains QR Code data',
			IsTitle: true,
			PathRoot: 'Items placed inside the HDon\\DLHDon\\NDHDon\\TToan tag'
		},
		{
			TargetName:
				'QR Code data (Details in Section 7, Section IV, Part I, Decision No. 1450/QD-TCT dated 7/10/2021)',
			TagNameCheck: 'DLQRCode',
			MaxLength: 512,
			DataType: 'String',
			Constraint: 'Not mandatory',
			IsTitle: false,
			PathRoot: 'HDon\\DLQRCode contains QR Code data'
		},
		{
			TargetName:
				'For invoices with codes, if conditions are met to issue codes, the tax authority system returns the item Tax authority code on electronic invoices (MCCQT tag, placed inside the HDon tag)',
			IsTitle: true,
			PathRoot: 'HDon\\DLQRCode contains QR Code data'
		},
		{
			TargetName: 'Tax authority code (Tax authority code on electronic invoices)',
			TagName: 'MCCQT',
			MaxLength: 34,
			DataType: 'String',
			Constraint: 'Mandatory',
			IsTitle: false,
			PathRoot:
				'For invoices with codes, if conditions are met to issue codes, the tax authority system returns the item Tax authority code on electronic invoices (MCCQT tag, placed inside the HDon tag)'
		},
		{
			TargetName: 'Tag HDon\\DSCKS\\Nban',
			IsTitle: true,
			PathRoot:
				'For invoices with codes, if conditions are met to issue codes, the tax authority system returns the item Tax authority code on electronic invoices (MCCQT tag, placed inside the HDon tag)'
		},
		{
			TargetName: "Seller's digital signature",
			TagName: 'Signature',
			Constraint: 'Mandatory (if available)',
			IsTitle: false,
			PathRoot: 'Tag HDon\\DSCKS\\Nban'
		},
		{
			TargetName: 'Tag HDon\\DSCKS\\Nmua',
			IsTitle: true,
			PathRoot: 'Tag HDon\\DSCKS\\Nban'
		},
		{
			TargetName: 'Digital signature of the buyer',
			TagName: 'Signature',
			Constraint: 'Not mandatory',
			IsTitle: false,
			PathRoot: 'Tag HDon\\DSCKS\\Nmua'
		},
		{
			TargetName:
				'For electronic invoices eligible for code issuance, the tax authority system returns the electronic invoice and adds the CQT tag (placed inside the HDonXDSCKS tag) containing the digital signature information of the tax authority (signed on the HDon\\DLHDon tag, MCCQT tag, and HDon\\DSCKS\\CQT\\Signature\\Object tag)',
			IsTitle: true,
			PathRoot: 'Tag HDon\\DSCKS\\Nmua'
		},
		{
			TargetName: 'Digital signature of the tax authority',
			TagName: 'Signature',
			Constraint: 'Mandatory',
			IsTitle: false,
			PathRoot:
				'For electronic invoices eligible for code issuance, the tax authority system returns the electronic invoice and adds the CQT tag (placed inside the HDonXDSCKS tag) containing the digital signature information of the tax authority (signed on the HDon\\DLHDon tag, MCCQT tag, and HDon\\DSCKS\\CQT\\Signature\\Object tag)'
		}
	],

	formatXMLValueTicketRegisterCash: [
		{
			TargetName: 'Tag HDon\\DLHDon\\TTChung',
			IsTitle: true
		},
		{
			TargetName: 'XML version',
			TagName: 'PBan',
			MaxLength: 6,
			DataType: 'String',
			Constraint: 'Mandatory',
			IsTitle: false,
			PathRoot: 'Tag HDon\\DLHDon\\TTChung'
		},
		{
			TargetName: 'Invoice name',
			TagName: 'THDon',
			MaxLength: 100,
			DataType: 'String',
			Constraint: 'Mandatory (if available)',
			IsTitle: false,
			PathRoot: 'Tag HDon\\DLHDon\\TTChung'
		},
		{
			TargetName: 'Pattern serial number of the invoice',
			TagName: 'KHMSHDon',
			MaxLength: 1,
			DataType: 'String (Details in Appendix 16 attached to Decision No. 1510/QD-TCT)',
			Constraint: 'Mandatory (if available)',
			IsTitle: false,
			PathRoot: 'Tag HDon\\DLHDon\\TTChung'
		},
		{
			TargetName: 'Invoice symbol',
			TagName: 'KHHDon',
			MaxLength: 6,
			DataType: 'String',
			Constraint: 'Mandatory (if available)',
			IsTitle: false,
			PathRoot: 'Tag HDon\\DLHDon\\TTChung'
		},
		{
			TargetName: 'Invoice number',
			TagName: 'SHDon',
			MaxLength: 8,
			DataType: 'Number',
			Constraint: 'Mandatory (if available)',
			IsTitle: false,
			PathRoot: 'Tag HDon\\DLHDon\\TTChung'
		},
		{
			TargetName: 'Date of issuance',
			TagName: 'NLap',
			DataType: 'Date',
			Constraint: 'Mandatory',
			IsTitle: false,
			PathRoot: 'Tag HDon\\DLHDon\\TTChung'
		},
		{
			TargetName:
				'Tag Hdon\\DLHDon\\TTChung\\TTHDLQuan invoices contain information on related invoices in cases of adjustment or replacement invoices',
			IsTitle: true,
			PathRoot: 'Tag HDon\\DLHDon\\TTChung'
		},
		{
			TargetName: 'Nature of the invoice',
			TagName: 'TCHDon',
			MaxLength: 1,
			DataType: 'Number (1: Replacement, 2: Adjustment)',
			Constraint: 'Mandatory',
			IsTitle: false,
			PathRoot:
				'Tag HDon\\DLHDon\\TTChung\\TTHDLQuan invoices contain information on related invoices in cases of adjustment or replacement invoices'
		},
		{
			TargetName: 'Type of related invoice (Type of replaced/adjusted invoice)',
			TagName: 'LHDCLQuan',
			MaxLength: 1,
			DataType: 'Number (Details in Appendix VI attached to Decision No. 1450/QD-TCT dated October 7, 2021)',
			Constraint: 'Mandatory',
			IsTitle: false,
			PathRoot:
				'Tag HDon\\DLHDon\\TTChung\\TTHDLQuan invoices contain information on related invoices in cases of adjustment or replacement invoices'
		},
		{
			TargetName: 'Template code of related invoice (Template code of replaced/adjusted invoice)',
			TagName: 'KHMSHDCLQuan',
			MaxLength: 11,
			DataType: 'String (Details in Section 16, Appendix II attached to Decision No. 1510/QD-TCT)',
			Constraint:
				'Mandatory (For adjustment or replacement cases of invoices with Template code, Invoice code, Invoice number)',
			IsTitle: false,
			PathRoot:
				'Tag HDon\\DLHDon\\TTChung\\TTHDLQuan invoices contain information on related invoices in cases of adjustment or replacement invoices'
		},
		{
			TargetName: 'Invoice code of related invoice (Invoice code of replaced/adjusted invoice)',
			TagName: 'KHHDCLQuan',
			MaxLength: 8,
			DataType: 'String',
			Constraint:
				'Mandatory (For adjustment or replacement cases of invoices with Template code, Invoice code, Invoice number)',
			IsTitle: false,
			PathRoot:
				'Tag HDon\\DLHDon\\TTChung\\TTHDLQuan invoices contain information on related invoices in cases of adjustment or replacement invoices'
		},
		{
			TargetName: 'Invoice number of related invoice (Invoice number of replaced/adjusted invoice)',
			TagName: 'SHDCLQuan',
			MaxLength: 8,
			DataType: 'String',
			Constraint:
				'Mandatory (For adjustment or replacement cases of invoices with Template code, Invoice code, Invoice number)',
			IsTitle: false,
			PathRoot:
				'Tag HDon\\DLHDon\\TTChung\\TTHDLQuan invoices contain information on related invoices in cases of adjustment or replacement invoices'
		},
		{
			TargetName: 'Date of related invoice (Date of replaced/adjusted invoice)',
			TagName: 'NLHDCLQuan',
			DataType: 'Date',
			Constraint: 'Mandatory',
			IsTitle: false,
			PathRoot:
				'Tag HDon\\DLHDon\\TTChung\\TTHDLQuan invoices contain information on related invoices in cases of adjustment or replacement invoices'
		},
		{
			TargetName: 'Note',
			TagName: 'GChu',
			MaxLength: 255,
			DataType: 'String',
			Constraint: 'Not mandatory',
			IsTitle: false,
			PathRoot:
				'Tag HDon\\DLHDon\\TTChung\\TTHDLQuan invoices contain information on related invoices in cases of adjustment or replacement invoices'
		},
		{
			TargetName: 'Tag HDon\\DLHDon\\NDHDon\\Nban',
			IsTitle: true,
			PathRoot:
				'Tag HDon\\DLHDon\\TTChung\\TTHDLQuan invoices contain information on related invoices in cases of adjustment or replacement invoices'
		},
		{
			TargetName: 'Name',
			TagName: 'Ten',
			MaxLength: 400,
			DataType: 'String',
			Constraint: 'Mandatory',
			IsTitle: false,
			PathRoot: 'Tag HDon\\DLHDon\\NDHDon\\Nban'
		},
		{
			TargetName: 'Tax code',
			TagName: 'MST',
			MaxLength: 14,
			DataType: 'String',
			Constraint: 'Mandatory',
			IsTitle: false,
			PathRoot: 'Tag HDon\\DLHDon\\NDHDon\\Nban'
		},
		{
			TargetName: 'Address',
			TagName: 'DChi',
			MaxLength: 400,
			DataType: 'String',
			Constraint: 'Mandatory',
			IsTitle: false,
			PathRoot: 'Tag HDon\\DLHDon\\NDHDon\\Nban'
		},
		{
			TargetName: 'Phone number',
			TagName: 'SDThoai',
			MaxLength: 20,
			DataType: 'String',
			Constraint: 'Not mandatory',
			IsTitle: false,
			PathRoot: 'Tag HDon\\DLHDon\\NDHDon\\Nban'
		},
		{
			TargetName: 'Tag HDon\\DLHDon\\NDHDon\\Nmua',
			IsTitle: true
		},
		{
			TargetName: 'Full name of buyer',
			TagName: 'HVTNMHang',
			MaxLength: 100,
			DataType: 'String',
			Constraint: 'Not mandatory',
			IsTitle: false,
			PathRoot: 'Tag HDon\\DLHDon\\NDHDon\\NMua'
		},
		{
			TargetName: 'Name',
			TagName: 'Ten',
			MaxLength: 400,
			DataType: 'String',
			Constraint: 'Not mandatory',
			IsTitle: false,
			PathRoot: 'Tag HDon\\DLHDon\\NDHDon\\Nmua'
		},
		{
			TargetName: 'Tax code',
			TagName: 'MST',
			MaxLength: 14,
			DataType: 'String',
			Constraint: 'Not mandatory',
			IsTitle: false,
			PathRoot: 'Tag HDon\\DLHDon\\NDHDon\\Nmua'
		},
		{
			TargetName: 'Budget relationship unit code',
			TagName: 'MDVQHNSach',
			MaxLength: 7,
			DataType: 'String',
			Constraint: 'Not mandatory',
			IsTitle: false,
			PathRoot: 'Tag HDon\\DLHDon\\NDHDon\\NMua'
		},
		{
			TargetName: 'Phone number',
			TagName: 'SDThoai',
			MaxLength: 20,
			DataType: 'String',
			Constraint: 'Not mandatory',
			IsTitle: false,
			PathRoot: 'Tag HDon\\DLHDon\\NDHDon\\Nmua'
		},
		{
			TargetName: 'Citizenship ID',
			TagName: 'CCCDan',
			MaxLength: 12,
			DataType: 'String',
			Constraint: 'Mandatory (if available)',
			IsTitle: false,
			PathRoot: 'Tag HDon\\DLHDon\\NDHDon\\NMua'
		},
		{
			TargetName: 'Passport number',
			TagName: 'SHChieu',
			MaxLength: 20,
			DataType: 'String',
			Constraint: 'Mandatory (if available)',
			IsTitle: false,
			PathRoot: 'Thẻ Hdon\\DLHDon\\NDHDon\\NMua'
		},
		{
			TargetName: 'Tag HDon\\DLHDon\\NDHDon\\DSHHDVu\\HHDVu',
			IsTitle: true
		},
		{
			TargetName: 'Nature',
			TagName: 'TChat',
			MaxLength: 1,
			DataType: 'Number (Details in Appendix IV attached to Decision No. 1450/QD-TCT dated 7/10/2021)',
			Constraint: 'Mandatory',
			IsTitle: false,
			PathRoot: 'Tag HDon\\DLHDon\\NDHDon\\DSHHDVu\\HHDVu'
		},
		{
			TargetName: 'No.',
			TagName: 'STT',
			MaxLength: 4,
			DataType: 'Number',
			Constraint: 'Not mandatory',
			IsTitle: false,
			PathRoot: 'Tag HDon\\DLHDon\\NDHDon\\DSHHDVu\\HHDVu'
		},
		{
			TargetName: 'Product, service code',
			TagName: 'MHHDVu',
			MaxLength: 50,
			DataType: 'String',
			Constraint: 'Mandatory (if available)',
			IsTitle: false,
			PathRoot: 'Tag HDon\\DLHDon\\NDHDon\\DSHHDVu\\HHDVu'
		},
		{
			TargetName: 'Product, service name',
			TagName: 'THHDVu',
			MaxLength: 500,
			DataType: 'String',
			Constraint: 'Mandatory',
			IsTitle: false,
			PathRoot: 'Tag HDon\\DLHDon\\NDHDon\\DSHHDVu\\HHDVu'
		},
		{
			TargetName: 'Unit',
			TagName: 'DVTinh',
			MaxLength: 50,
			DataType: 'String',
			Constraint: 'Mandatory (if available)',
			IsTitle: false,
			PathRoot: 'Tag HDon\\DLHDon\\NDHDon\\DSHHDVu\\HHDVu'
		},
		{
			TargetName: 'Quantity',
			TagName: 'SLuong',
			MaxLength: '21.6',
			DataType: 'Number',
			Constraint: 'Mandatory (if available)',
			IsTitle: false,
			PathRoot: 'Tag HDon\\DLHDon\\NDHDon\\DSHHDVu\\HHDVu'
		},
		{
			TargetName: 'Unit price',
			TagName: 'DGia',
			MaxLength: '21.6',
			DataType: 'Number',
			Constraint: 'Mandatory (if available)',
			IsTitle: false,
			PathRoot: 'Tag HDon\\DLHDon\\NDHDon\\DSHHDVu\\HHDVu'
		},
		{
			TargetName: 'Discount rate (%) (In case of showing discount information for each item or service)',
			TagName: 'TLCKhau',
			MaxLength: '6.4',
			DataType: 'Number',
			Constraint: 'Not mandatory',
			IsTitle: false,
			PathRoot: 'Tag HDon\\DLHDon\\NDHDon\\DSHHDVu\\HHDVu'
		},
		{
			TargetName: 'Discount amount (In case of showing discount information for each item or service)',
			TagName: 'STCKhau',
			MaxLength: '21.6',
			DataType: 'Number',
			Constraint: 'Not mandatory',
			IsTitle: false,
			PathRoot: 'Tag HDon\\DLHDon\\NDHDon\\DSHHDVu\\HHDVu'
		},
		{
			TargetName: 'Total amount (Total amount excluding VAT)',
			TagName: 'ThTien',
			MaxLength: '21.6',
			DataType: 'Number',
			Constraint: 'Mandatory (except when TChat has the value “4-Note/explanation”)',
			IsTitle: false,
			PathRoot: 'Tag HDon\\DLHDon\\NDHDon\\DSHHDVu\\HHDVu'
		},
		{
			TargetName:
				'Tax rate (VAT rate for invoices other than VAT invoices, for invoices other than sales invoices, this tag is not available)',
			TagName: 'TSuat',
			MaxLength: 11,
			DataType: 'String (Details in Section 17 of the Appendix attached to Decision No. 1510/QD-TCT)',
			Constraint: 'Mandatory (if available)',
			IsTitle: false,
			PathRoot: 'Tag HDon\\DLHDon\\NDHDon\\DSHHDVu\\HHDVu'
		},
		{
			TargetName:
				'Tag HDon\\DLHDon\\NDHDon\\TToan\\THTTLTSuat\\LTSuat contains detailed information on the summary of each tax rate (if available)',
			IsTitle: true
		},
		{
			TargetName: 'Tax rate (VAT tax rate)',
			TagName: 'TSuat',
			MaxLength: 11,
			DataType: 'String (Details in Section 17 of the Appendix attached to Decision No. 1510/QD-TCT)',
			Constraint: 'Mandatory (if available)',
			IsTitle: false,
			PathRoot:
				'Tag HDon\\DLHDon\\NDHDon\\TToan\\THTTLTSuat\\LTSuat contains detailed information on the summary of each tax rate (if available)'
		},
		{
			TargetName: 'Total amount (Total amount excluding VAT)',
			TagName: 'ThTien',
			MaxLength: '21.6',
			DataType: 'Number',
			Constraint: 'Mandatory',
			IsTitle: false,
			PathRoot:
				'Tag HDon\\DLHDon\\NDHDon\\TToan\\THTTLTSuat\\LTSuat contains detailed information on the summary of each tax rate (if available)'
		},
		{
			TargetName: 'Tax amount (VAT tax amount)',
			TagName: 'TThue',
			MaxLength: '21.6',
			DataType: 'Number',
			Constraint: 'Mandatory (if available)',
			IsTitle: false,
			PathRoot:
				'Tag HDon\\DLHDon\\NDHDon\\TToan\\THTTLTSuat\\LTSuat contains detailed information on the summary of each tax rate (if available)'
		},
		{
			TargetName: 'Tag HDon\\DLHDon\\NDHDon\\Ttoan',
			IsTitle: true
		},
		{
			TargetName: 'Total amount excluding tax (Total amount excluding VAT)',
			TagName: 'TgTCThue',
			MaxLength: '21.6',
			DataType: 'Number',
			Constraint: 'Mandatory',
			IsTitle: false,
			PathRoot: 'Tag HDon\\DLHDon\\NDHDon\\Ttoan'
		},
		{
			TargetName: 'Total tax amount (Total VAT amount)',
			TagName: 'TgTThue',
			MaxLength: '21.6',
			DataType: 'Number',
			Constraint: 'Mandatory',
			IsTitle: false,
			PathRoot: 'Tag HDon\\DLHDon\\NDHDon\\Ttoan'
		},
		{
			TargetName: 'Items placed inside the HDon\\DLHDon\\NDHDon\\TToan tag',
			IsTitle: true
		},
		{
			TargetName: 'Total commercial discount amount',
			TagName: 'TTCKTMai',
			MaxLength: '21.6',
			DataType: 'Number',
			Constraint: 'Mandatory (if available)',
			IsTitle: false,
			PathRoot: 'Items placed inside the HDon\\DLHDon\\NDHDon\\TToan'
		},
		{
			TargetName: 'Total payment amount in numbers',
			TagName: 'TgTTTBSo',
			MaxLength: '21.6',
			DataType: 'Number',
			Constraint: 'Mandatory',
			IsTitle: false,
			PathRoot: 'Items placed inside the HDon\\DLHDon\\NDHDon\\TToan'
		},
		{
			TargetName: 'Total payment amount in words',
			TagName: 'TgTTTBChu',
			MaxLength: 255,
			DataType: 'String',
			Constraint: 'Mandatory',
			IsTitle: false,
			PathRoot: 'Items placed inside the HDon\\DLHDon\\NDHDon\\TToan'
		},
		{
			TargetName: 'HDon\\DLQRCode contains QR Code data',
			IsTitle: true
		},
		{
			TargetName:
				'QR Code data (Details in Section 7, Section IV, Part I, Decision No. 1450/QD-TCT dated 7/10/2021)',
			MaxLength: 512,
			DataType: 'String',
			Constraint: 'Not mandatory',
			IsTitle: false,
			PathRoot: 'Tag HDon\\DLQRCode contains QR Code data'
		},
		{
			TargetName:
				'Tag HDon\\MCCQT contains the tax authority code information on the electronic invoice generated from the cash register.',
			IsTitle: true
		},
		{
			TargetName: 'Tax authority code (Tax authority code on electronic invoices)',
			TagName: 'MCCQT',
			MaxLength: 23,
			DataType: 'String',
			Constraint: 'Mandatory',
			IsTitle: false,
			PathRoot:
				'Tag HDon\\MCCQT contains the tax authority code information on the electronic invoice generated from the cash register.'
		},
		{
			TargetName: 'Tag HDon\\DSCKS\\Nban',
			IsTitle: true,
			PathRoot:
				'Tag HDon\\MCCQT contains the tax authority code information on the electronic invoice generated from the cash register.'
		},
		{
			TargetName: 'Digital signature of the seller',
			TagName: 'Signature',
			Constraint: 'Not mandatory',
			IsTitle: false,
			PathRoot: 'Tag HDon\\DSCKS\\Nban'
		}
	],

	formatXMLSaleTicket: [
		{
			TargetName: 'Tag HDon\\DLHDon\\TTChung',
			IsTitle: true,
			PathRoot: ''
		},
		{
			TargetName: 'XML version',
			TagName: 'PBan',
			MaxLength: 6,
			DataType: 'String',
			Constraint: 'Mandatory',
			IsTitle: false,
			PathRoot: 'Tag HDon\\DLHDon\\TTChung'
		},
		{
			TargetName: 'Invoice name',
			TagName: 'THDon',
			MaxLength: 100,
			DataType: 'String',
			Constraint: 'Mandatory (if available)',
			IsTitle: false,
			PathRoot: 'Tag HDon\\DLHDon\\TTChung'
		},
		{
			TargetName: 'Pattern serial number of the invoice',
			TagName: 'KHMSHDon',
			MaxLength: 1,
			DataType: 'String (Details in Appendix 16 attached to Decision No. 1510/QD-TCT)',
			Constraint: 'Mandatory (if available)',
			IsTitle: false,
			PathRoot: 'Tag HDon\\DLHDon\\TTChung'
		},
		{
			TargetName: 'Invoice symbol',
			TagName: 'KHHDon',
			MaxLength: 6,
			DataType: 'String',
			Constraint: 'Mandatory (if available)',
			IsTitle: false,
			PathRoot: 'Tag HDon\\DLHDon\\TTChung'
		},
		{
			TargetName: 'Invoice number',
			TagName: 'SHDon',
			MaxLength: 8,
			DataType: 'Number',
			Constraint: 'Mandatory (if available)',
			IsTitle: false,
			PathRoot: 'Tag HDon\\DLHDon\\TTChung'
		},
		{
			TargetName: 'Date of issuance',
			TagName: 'NLap',
			DataType: 'Date',
			Constraint: 'Mandatory',
			IsTitle: false,
			PathRoot: 'Tag HDon\\DLHDon\\TTChung'
		},
		{
			TargetName: 'Currency unit',
			TagName: 'DVTTe',
			MaxLength: 3,
			DataType:
				'String (Details in Section 2, Section IV, Part I of Decision No. 1450/QD-TCT dated October 7, 2021)',
			Constraint: 'Mandatory',
			IsTitle: false,
			PathRoot: 'Tag Hdon\\DLHDon\\TTChung'
		},
		{
			TargetName: 'Exchange rate',
			TagName: 'TGia',
			MaxLength: '7.2',
			DataType: 'Number',
			Constraint: 'Mandatory (Except when the Currency unit is VND)',
			IsTitle: false,
			PathRoot: 'Tag Hdon\\DLHDon\\TTChung'
		},
		{
			TargetName: 'Payment method',
			TagName: 'HTTToan',
			MaxLength: 50,
			DataType: 'String',
			Constraint: 'Not mandatory',
			IsTitle: false,
			PathRoot: 'Tag Hdon\\DLHDon\\TTChung'
		},
		{
			TargetName:
				'Taxpayer Identification Number (TIN) of the organization providing electronic invoice solutions',
			TagName: 'MSTTCGP',
			MaxLength: 14,
			DataType: 'String',
			Constraint:
				"Mandatory (except for cases of issuing electronic invoices with codes not collected on the tax authority's electronic portal)",
			IsTitle: false,
			PathRoot: 'Tag Hdon\\DLHDon\\TTChung'
		},
		{
			TargetName: 'Taxpayer Identification Number (TIN) of the unit authorized to issue invoices',
			TagName: 'MSTDVNUNLHDon',
			MaxLength: 14,
			DataType: 'String',
			Constraint: 'Mandatory (For cases of invoice authorization)',
			IsTitle: false,
			PathRoot: 'Tag Hdon\\DLHDon\\TTChung'
		},
		{
			TargetName: 'Name of the unit authorized to issue invoices',
			TagName: 'TDVNUNLHDon',
			MaxLength: 400,
			DataType: 'String',
			Constraint: 'Mandatory (For cases of invoice authorization)',
			IsTitle: false,
			PathRoot: 'Tag Hdon\\DLHDon\\TTChung'
		},
		{
			TargetName: 'Address of the unit authorized to issue invoices',
			TagName: 'DCDVNUNLHDon',
			MaxLength: 400,
			DataType: 'String',
			Constraint: 'Mandatory (For cases of invoice authorization)',
			IsTitle: false,
			PathRoot: 'Tag Hdon\\DLHDon\\TTChung'
		},
		{
			TargetName:
				'Tag HDon\\DLHDon\\TTChung\\TTHDLQuan invoices contain information on related invoices in cases of adjustment or replacement invoices',
			IsTitle: true,
			PathRoot: 'Tag HDon\\DLHDon\\TTChung'
		},
		{
			TargetName: 'Nature of the invoice',
			TagName: 'TCHDon',
			MaxLength: 1,
			DataType: 'Number (1: Replacement, 2: Adjustment)',
			Constraint: 'Mandatory',
			IsTitle: false,
			PathRoot:
				'Tag HDon\\DLHDon\\TTChung\\TTHDLQuan invoices contain information on related invoices in cases of adjustment or replacement invoices'
		},
		{
			TargetName: 'Type of related invoice (Type of replaced/adjusted invoice)',
			TagName: 'LHDCLQuan',
			MaxLength: 1,
			DataType: 'Number (Details in Appendix VI attached to Decision No. 1450/QD-TCT dated October 7, 2021)',
			Constraint: 'Mandatory',
			IsTitle: false,
			PathRoot:
				'Tag HDon\\DLHDon\\TTChung\\TTHDLQuan invoices contain information on related invoices in cases of adjustment or replacement invoices'
		},
		{
			TargetName: 'Template code of related invoice (Template code of replaced/adjusted invoice)',
			TagName: 'KHMSHDCLQuan',
			MaxLength: 11,
			DataType: 'String (Details in Section 16, Appendix attached to Decision No. 1450/QD-TCT)',
			Constraint:
				'Mandatory (For adjustment or replacement cases of invoices with Template code, Invoice code, Invoice number)',
			IsTitle: false,
			PathRoot:
				'Tag HDon\\DLHDon\\TTChung\\TTHDLQuan invoices contain information on related invoices in cases of adjustment or replacement invoices'
		},
		{
			TargetName: 'Invoice code of related invoice (Invoice code of replaced/adjusted invoice)',
			TagName: 'KHHDCLQuan',
			MaxLength: 8,
			DataType: 'String',
			Constraint:
				'Mandatory (For adjustment or replacement cases of invoices with Template code, Invoice code, Invoice number)',
			IsTitle: false,
			PathRoot:
				'Tag HDon\\DLHDon\\TTChung\\TTHDLQuan invoices contain information on related invoices in cases of adjustment or replacement invoices'
		},
		{
			TargetName: 'Invoice number of related invoice (Invoice number of replaced/adjusted invoice)',
			TagName: 'SHDCLQuan',
			MaxLength: 8,
			DataType: 'String',
			Constraint:
				'Mandatory (For adjustment or replacement cases of invoices with Template code, Invoice code, Invoice number)',
			IsTitle: false,
			PathRoot:
				'Tag HDon\\DLHDon\\TTChung\\TTHDLQuan invoices contain information on related invoices in cases of adjustment or replacement invoices'
		},
		{
			TargetName: 'Date of related invoice (Date of replaced/adjusted invoice)',
			TagName: 'NLHDCLQuan',
			DataType: 'Date',
			Constraint: 'Mandatory',
			IsTitle: false,
			PathRoot:
				'Tag HDon\\DLHDon\\TTChung\\TTHDLQuan invoices contain information on related invoices in cases of adjustment or replacement invoices'
		},
		{
			TargetName: 'Note',
			TagName: 'GChu',
			MaxLength: 255,
			DataType: 'String',
			Constraint: 'Not mandatory',
			IsTitle: false,
			PathRoot:
				'Tag HDon\\DLHDon\\TTChung\\TTHDLQuan invoices contain information on related invoices in cases of adjustment or replacement invoices'
		},
		{
			TargetName: 'Tag HDon\\DLHDon\\NDHDon\\Nban',
			IsTitle: true
		},
		{
			TargetName: 'Name',
			TagName: 'Ten',
			MaxLength: 400,
			DataType: 'String',
			Constraint: 'Mandatory',
			IsTitle: false,
			PathRoot: 'Tag HDon\\DLHDon\\NDHDon\\Nban'
		},
		{
			TargetName: 'Tax code',
			TagName: 'MST',
			MaxLength: 14,
			DataType: 'String',
			Constraint: 'Mandatory',
			IsTitle: false,
			PathRoot: 'Tag HDon\\DLHDon\\NDHDon\\Nban'
		},
		{
			TargetName: 'Address',
			TagName: 'DChi',
			MaxLength: 400,
			DataType: 'String',
			Constraint: 'Mandatory',
			IsTitle: false,
			PathRoot: 'Tag HDon\\DLHDon\\NDHDon\\Nban'
		},
		{
			TargetName: 'Phone number',
			TagName: 'SDThoai',
			MaxLength: 20,
			DataType: 'String',
			Constraint: 'Not mandatory',
			IsTitle: false,
			PathRoot: 'Tag HDon\\DLHDon\\NDHDon\\Nban'
		},
		{
			TargetName: 'Email address',
			TagName: 'DCTDTu',
			MaxLength: 50,
			DataType: 'String',
			Constraint: 'Not mandatory',
			IsTitle: false,
			PathRoot: 'Tag HDon\\DLHDon\\NDHDon\\Nban'
		},
		{
			TargetName: 'Bank account number',
			TagName: 'STKNHang',
			MaxLength: 30,
			DataType: 'String',
			Constraint: 'Not mandatory',
			IsTitle: false,
			PathRoot: 'Tag HDon\\DLHDon\\NDHDon\\Nban'
		},
		{
			TargetName: 'Bank name',
			TagName: 'TNHang',
			MaxLength: 400,
			DataType: 'String',
			Constraint: 'Not mandatory',
			IsTitle: false,
			PathRoot: 'Tag HDon\\DLHDon\\NDHDon\\Nban'
		},
		{
			TargetName: 'Fax',
			TagName: 'Fax',
			MaxLength: 20,
			DataType: 'String',
			Constraint: 'Not mandatory',
			IsTitle: false,
			PathRoot: 'Tag HDon\\DLHDon\\NDHDon\\Nban'
		},
		{
			TargetName: 'Website',
			TagName: 'Website',
			MaxLength: 100,
			DataType: 'String',
			Constraint: 'Not mandatory',
			IsTitle: false,
			PathRoot: 'Tag HDon\\DLHDon\\NDHDon\\Nban'
		},
		{
			TargetName: 'Tag HDon\\DLHDon\\NDHDon\\Nmua',
			IsTitle: true
		},
		{
			TargetName: 'Name',
			TagName: 'Ten',
			MaxLength: 400,
			DataType: 'String',
			Constraint: 'Not mandatory',
			IsTitle: false,
			PathRoot: 'Tag HDon\\DLHDon\\NDHDon\\Nmua'
		},
		{
			TargetName: 'Tax code',
			TagName: 'MST',
			MaxLength: 14,
			DataType: 'String',
			Constraint: 'Not mandatory',
			IsTitle: false,
			PathRoot: 'Tag HDon\\DLHDon\\NDHDon\\Nmua'
		},
		{
			TargetName: 'Budget relationship unit code',
			TagName: 'MDVQHNSach',
			MaxLength: 7,
			DataType: 'String',
			Constraint: 'Not mandatory',
			IsTitle: false,
			PathRoot: 'Tag HDon\\DLHDon\\NDHDon\\NMua'
		},
		{
			TargetName: 'Address',
			TagName: 'DChi',
			MaxLength: 400,
			DataType: 'String',
			Constraint: 'Not mandatory',
			IsTitle: false,
			PathRoot: 'Tag HDon\\DLHDon\\NDHDon\\Nmua'
		},
		{
			TargetName: 'Customer code',
			TagName: 'MKHang',
			MaxLength: 50,
			DataType: 'String',
			Constraint: 'Not mandatory',
			IsTitle: false,
			PathRoot: 'Tag HDon\\DLHDon\\NDHDon\\Nmua'
		},
		{
			TargetName: 'Citizenship ID',
			TagName: 'CCCDan',
			MaxLength: 12,
			DataType: 'String',
			Constraint: 'Mandatory (if available)',
			IsTitle: false,
			PathRoot: 'Tag HDon\\DLHDon\\NDHDon\\NMua'
		},
		{
			TargetName: 'Passport number',
			TagName: 'SHChieu',
			MaxLength: 20,
			DataType: 'String',
			Constraint: 'Mandatory (if available)',
			IsTitle: false,
			PathRoot: 'Thẻ Hdon\\DLHDon\\NDHDon\\NMua'
		},
		{
			TargetName: 'Phone number',
			TagName: 'SDThoai',
			MaxLength: 20,
			DataType: 'String',
			Constraint: 'Not mandatory',
			IsTitle: false,
			PathRoot: 'Tag HDon\\DLHDon\\NDHDon\\Nmua'
		},
		{
			TargetName: 'Email address',
			TagName: 'DCTDTu',
			MaxLength: 50,
			DataType: 'String',
			Constraint: 'Not mandatory',
			IsTitle: false,
			PathRoot: 'Tag HDon\\DLHDon\\NDHDon\\Nmua'
		},
		{
			TargetName: 'Full name of buyer',
			TagName: 'HVTNMHang',
			MaxLength: 100,
			DataType: 'String',
			Constraint: 'Not mandatory',
			IsTitle: false,
			PathRoot: 'Tag HDon\\DLHDon\\NDHDon\\Nmua'
		},
		{
			TargetName: 'Bank account number',
			TagName: 'STKNHang',
			MaxLength: 30,
			DataType: 'String',
			Constraint: 'Not mandatory',
			IsTitle: false,
			PathRoot: 'Tag HDon\\DLHDon\\NDHDon\\Nmua'
		},
		{
			TargetName: 'Bank name',
			TagName: 'TNHang',
			MaxLength: 400,
			DataType: 'String',
			Constraint: 'Not mandatory',
			IsTitle: false,
			PathRoot: 'Tag HDon\\DLHDon\\NDHDon\\Nmua'
		},
		{
			TargetName: 'Tag HDon\\DLHDon\\NDHDon\\DSHHDVu\\HHDVu',
			IsTitle: true
		},
		{
			TargetName: 'Nature',
			TagName: 'TChat',
			MaxLength: 1,
			DataType: 'Number (Details in Appendix IV attached to Decision No. 1450/QD-TCT dated 7/10/2021)',
			Constraint: 'Mandatory',
			IsTitle: false,
			PathRoot: 'Tag HDon\\DLHDon\\NDHDon\\DSHHDVu\\HHDVu'
		},
		{
			TargetName: 'No.',
			TagName: 'STT',
			MaxLength: 4,
			DataType: 'Number',
			Constraint: 'Not mandatory',
			IsTitle: false,
			PathRoot: 'Tag HDon\\DLHDon\\NDHDon\\DSHHDVu\\HHDVu'
		},
		{
			TargetName: 'Product, service code',
			TagName: 'MHHDVu',
			MaxLength: 50,
			DataType: 'String',
			Constraint: 'Mandatory (if available)',
			IsTitle: false,
			PathRoot: 'Tag HDon\\DLHDon\\NDHDon\\DSHHDVu\\HHDVu'
		},
		{
			TargetName: 'Product, service name',
			TagName: 'THHDVu',
			MaxLength: 500,
			DataType: 'String',
			Constraint: 'Mandatory',
			IsTitle: false,
			PathRoot: 'Tag HDon\\DLHDon\\NDHDon\\DSHHDVu\\HHDVu'
		},
		{
			TargetName: 'Unit',
			TagName: 'DVTinh',
			MaxLength: 50,
			DataType: 'String',
			Constraint: 'Mandatory (if available)',
			IsTitle: false,
			PathRoot: 'Tag HDon\\DLHDon\\NDHDon\\DSHHDVu\\HHDVu'
		},
		{
			TargetName: 'Quantity',
			TagName: 'SLuong',
			MaxLength: '21.6',
			DataType: 'Number',
			Constraint: 'Mandatory (if available)',
			IsTitle: false,
			PathRoot: 'Tag HDon\\DLHDon\\NDHDon\\DSHHDVu\\HHDVu'
		},
		{
			TargetName: 'Unit price',
			TagName: 'DGia',
			MaxLength: '21.6',
			DataType: 'Number',
			Constraint: 'Mandatory (if available)',
			IsTitle: false,
			PathRoot: 'Tag HDon\\DLHDon\\NDHDon\\DSHHDVu\\HHDVu'
		},
		{
			TargetName: 'Discount rate (%) (In case of showing discount information for each item or service)',
			TagName: 'TLCKhau',
			MaxLength: '6.4',
			DataType: 'Number',
			Constraint: 'Not mandatory',
			IsTitle: false,
			PathRoot: 'Tag HDon\\DLHDon\\NDHDon\\DSHHDVu\\HHDVu'
		},
		{
			TargetName: 'Discount amount (In case of showing discount information for each item or service)',
			TagName: 'STCKhau',
			MaxLength: '21.6',
			DataType: 'Number',
			Constraint: 'Not mandatory',
			IsTitle: false,
			PathRoot: 'Tag HDon\\DLHDon\\NDHDon\\DSHHDVu\\HHDVu'
		},
		{
			TargetName: 'Total amount (Total amount excluding VAT)',
			TagName: 'ThTien',
			MaxLength: '21.6',
			DataType: 'Number',
			Constraint: 'Mandatory (except when TChat has the value “4-Note/explanation”)',
			IsTitle: false,
			PathRoot: 'Tag HDon\\DLHDon\\NDHDon\\DSHHDVu\\HHDVu'
		},
		{
			TargetName:
				'Tax rate (VAT rate for invoices other than VAT invoices, for invoices other than sales invoices, this tag is not available)',
			TagName: 'TSuat',
			MaxLength: 11,
			DataType: 'String (Details in Section 17 of the Appendix attached to Decision No. 1450/QD-TCT)',
			Constraint: 'Mandatory (if available)',
			IsTitle: false,
			PathRoot: 'Tag HDon\\DLHDon\\NDHDon\\DSHHDVu\\HHDVu'
		},
		{
			TargetName: 'Tag HDon\\DLHDon\\NDHDon\\TToan\\DSLPhi\\Lphi',
			IsTitle: true
		},
		{
			TargetName: 'Fee name',
			TagName: 'TLPhi',
			MaxLength: 100,
			DataType: 'String',
			Constraint: 'Mandatory (if available)',
			IsTitle: false,
			PathRoot: 'Tag HDon\\DLHDon\\NDHDon\\TToan\\DSLPhi\\Lphi'
		},
		{
			TargetName: 'Fee amount',
			TagName: 'TPhi',
			MaxLength: '21.6',
			DataType: 'Number',
			Constraint: 'Mandatory (if available)',
			IsTitle: false,
			PathRoot: 'Tag HDon\\DLHDon\\NDHDon\\TToan\\DSLPhi\\Lphi'
		},
		{
			TargetName: 'Items placed inside the HDon\\DLHDon\\NDHDon\\TToan tag',
			IsTitle: true
		},
		{
			TargetName: 'Total commercial discount amount',
			TagName: 'TTCKTMai',
			MaxLength: '21.6',
			DataType: 'Number',
			Constraint: 'Mandatory (if available)',
			IsTitle: false,
			PathRoot: 'Items placed inside the HDon\\DLHDon\\NDHDon\\TToan tag'
		},
		{
			TargetName: 'Other deduction total',
			TagName: 'TGTKhac',
			MaxLength: '21.6',
			DataType: 'Number',
			Constraint: 'Not mandatory',
			IsTitle: false,
			PathRoot: 'Items placed inside the HDon\\DLHDon\\NDHDon\\TToan tag'
		},
		{
			TargetName: 'Total payment amount in numbers',
			TagName: 'TgTTTBSo',
			MaxLength: '21.6',
			DataType: 'Number',
			Constraint: 'Mandatory',
			IsTitle: false,
			PathRoot: 'Items placed inside the HDon\\DLHDon\\NDHDon\\TToan tag'
		},
		{
			TargetName: 'Total payment amount in words',
			TagName: 'TgTTTBChu',
			MaxLength: 255,
			DataType: 'String',
			Constraint: 'Mandatory',
			IsTitle: false,
			PathRoot: 'Items placed inside the HDon\\DLHDon\\NDHDon\\TToan tag'
		},
		{
			TargetName: 'Tag HDon\\DLQRCode contains QR Code data',
			IsTitle: true
		},
		{
			TargetName:
				'QR Code data (Details in Section 7, Section IV, Part I, Decision No. 1450/QD-TCT dated 7/10/2021)',
			TagNameCheck: 'DLQRCode',
			MaxLength: 512,
			DataType: 'String',
			Constraint: 'Not mandatory',
			IsTitle: false,
			PathRoot: 'HDon\\DLQRCode contains QR Code data'
		},
		{
			TargetName:
				'For invoices with codes, if conditions are met to issue codes, the tax authority system returns the item Tax authority code on electronic invoices (MCCQT tag, placed inside the HDon tag)',
			IsTitle: true
		},
		{
			TargetName: 'Tax authority code (Tax authority code on electronic invoices)',
			TagName: 'MCCQT',
			MaxLength: 34,
			DataType: 'String',
			Constraint: 'Mandatory',
			IsTitle: false,
			PathRoot:
				'For invoices with codes, if conditions are met to issue codes, the tax authority system returns the item Tax authority code on electronic invoices (MCCQT tag, placed inside the HDon tag)'
		},
		{
			TargetName: 'Tag HDon\\DSCKS\\Nban',
			IsTitle: true
		},
		{
			TargetName: "Seller's digital signature",
			TagName: 'Signature',
			Constraint: 'Mandatory (if available)',
			IsTitle: false,
			PathRoot: 'Tag HDon\\DSCKS\\Nban'
		},
		{
			TargetName: 'Tag HDon\\DSCKS\\Nmua',
			IsTitle: true
		},
		{
			TargetName: 'Digital signature of the buyer',
			TagName: 'Signature',
			Constraint: 'Not mandatory',
			IsTitle: false,
			PathRoot: 'Tag HDon\\DSCKS\\Nmua'
		},
		{
			TargetName:
				'For electronic invoices eligible for code issuance, the tax authority system returns the electronic invoice and adds the CQT tag (placed inside the HDonXDSCKS tag) containing the digital signature information of the tax authority (signed on the HDon\\DLHDon tag, MCCQT tag, and HDon\\DSCKS\\CQT\\Signature\\Object tag)',
			IsTitle: true
		},
		{
			TargetName: 'Digital signature of the tax authority',
			TagName: 'Signature',
			Constraint: 'Mandatory',
			IsTitle: false,
			PathRoot:
				'For electronic invoices eligible for code issuance, the tax authority system returns the electronic invoice and adds the CQT tag (placed inside the HDonXDSCKS tag) containing the digital signature information of the tax authority (signed on the HDon\\DLHDon tag, MCCQT tag, and HDon\\DSCKS\\CQT\\Signature\\Object tag)'
		}
	]
};
